/* eslint-disable @typescript-eslint/no-namespace */ /* eslint-disable camelcase */ /* eslint-disable no-redeclare */ /* eslint-disable no-use-before-define */ /* This file should contain all the app constants which we use in the SPZA project */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { stringifyError } from '@shared/utils/errorUtils';
export var IConsentOption = /*#__PURE__*/ function(IConsentOption) {
    /** Requires users to manually tick the lead generation box to enable - default is disabled */ IConsentOption["OptIn"] = "optin";
    /** Requires users to manually tick the lead generation box to disable - default is enabled */ IConsentOption["OptOut"] = "optout";
    /** No checkbox, leads should be sent and this is for a notice only */ IConsentOption["Notice"] = "notice";
    /** Text is different no leads are sent. */ IConsentOption["Exclude"] = "exclude";
    /** Treated as OptIn */ IConsentOption["Unknown"] = "unknown";
    return IConsentOption;
}({});
export var LoginType = /*#__PURE__*/ function(LoginType) {
    LoginType["Silent"] = "Silent";
    LoginType["Implicit"] = "Implicit";
    return LoginType;
}({});
(function(Constants) {
    (function(Environment) {
        Environment["development"] = "development";
        Environment["df"] = "df";
        Environment["canary"] = "canary";
        Environment["prod"] = "prod";
    })(Constants.Environment || (Constants.Environment = {}));
    Constants.MSTenantId = '72f988bf-86f1-41af-91ab-2d7cd011db47';
    (function(AppName) {
        AppName["AppSource"] = "appsource";
    })(Constants.AppName || (Constants.AppName = {}));
    Constants.UNKNOWN_NETWORK_INFO = 'unknown';
    Constants.notAvailable = 'N/A';
    (function(Featured) {
        Featured.AppDocId = 'featuredapps';
        Featured.ServiceDocId = 'featuredservices';
    })(Constants.Featured || (Constants.Featured = {}));
    (function(Tabs) {
        Tabs["PlansAndPrice"] = "PlansAndPrice";
        Tabs["Overview"] = "Overview";
        Tabs["DetailsAndSupport"] = "DetailsAndSupport";
        Tabs["Reviews"] = "Reviews";
        Tabs["Linkedin"] = "Linkedin";
    })(Constants.Tabs || (Constants.Tabs = {}));
    (function(FilteredSearchType) {
        FilteredSearchType["All"] = "All";
        FilteredSearchType["Apps"] = "Apps";
        FilteredSearchType["Services"] = "Services";
        FilteredSearchType["CloudsIndustry"] = "CloudsIndustry";
        FilteredSearchType["Partners"] = "Partners";
    })(Constants.FilteredSearchType || (Constants.FilteredSearchType = {}));
    (function(FilteredSearchPhase) {
        FilteredSearchPhase["Started"] = "Started";
        FilteredSearchPhase["SearchResultsReturned"] = "Search Results Returned";
        FilteredSearchPhase["DuplicateAddInsRemoved"] = "Duplicate Add Ins Removed";
        FilteredSearchPhase["SearchActionCreated"] = "Search Action Created";
        FilteredSearchPhase["SearchTelemetryLogged"] = "Search Telemetry Logged";
    })(Constants.FilteredSearchPhase || (Constants.FilteredSearchPhase = {}));
    (function(HTMLElements) {
        HTMLElements["INPUT"] = "INPUT";
        HTMLElements["BUTTON"] = "BUTTON";
    })(Constants.HTMLElements || (Constants.HTMLElements = {}));
    (function(SigninStatus) {
        SigninStatus[SigninStatus["ValidTokenValidCookie"] = 1] = "ValidTokenValidCookie";
        SigninStatus[SigninStatus["ExpiredTokenValidCookie"] = 2] = "ExpiredTokenValidCookie";
        SigninStatus[SigninStatus["ExpiredTokenInvalidCookie"] = 3] = "ExpiredTokenInvalidCookie";
        SigninStatus[SigninStatus["ValidTokenInvalidCookie"] = 4] = "ValidTokenInvalidCookie";
        // Only client side state, where you cannot read the cookie and tell
        SigninStatus[SigninStatus["ValidTokenUnknownCookie"] = 5] = "ValidTokenUnknownCookie";
        SigninStatus[SigninStatus["ValidationSkipped"] = 6] = "ValidationSkipped";
    })(Constants.SigninStatus || (Constants.SigninStatus = {}));
    (function(PageToGiveMetaTag) {
        PageToGiveMetaTag[PageToGiveMetaTag["PageNotReady"] = -1] = "PageNotReady";
        PageToGiveMetaTag[PageToGiveMetaTag["SpzaHomePage"] = 1] = "SpzaHomePage";
        PageToGiveMetaTag[PageToGiveMetaTag["SpzaGalleryPage"] = 2] = "SpzaGalleryPage";
        PageToGiveMetaTag[PageToGiveMetaTag["SpzaCSGalleryPage"] = 3] = "SpzaCSGalleryPage";
        PageToGiveMetaTag[PageToGiveMetaTag["SpzaDetailPage"] = 4] = "SpzaDetailPage";
        PageToGiveMetaTag[PageToGiveMetaTag["SpzaCSDetailPage"] = 5] = "SpzaCSDetailPage";
        PageToGiveMetaTag[PageToGiveMetaTag["SpzaWordGalleryPage"] = 6] = "SpzaWordGalleryPage";
        PageToGiveMetaTag[PageToGiveMetaTag["SpzaExcelGalleryPage"] = 7] = "SpzaExcelGalleryPage";
        PageToGiveMetaTag[PageToGiveMetaTag["SpzaPowerpointGalleryPage"] = 8] = "SpzaPowerpointGalleryPage";
        PageToGiveMetaTag[PageToGiveMetaTag["SpzaOutlookGalleryPage"] = 9] = "SpzaOutlookGalleryPage";
        PageToGiveMetaTag[PageToGiveMetaTag["SpzaOfficeGalleryPage"] = 10] = "SpzaOfficeGalleryPage";
    })(Constants.PageToGiveMetaTag || (Constants.PageToGiveMetaTag = {}));
    (function(RatingShowMode) {
        RatingShowMode[RatingShowMode["Error"] = 1] = "Error";
        RatingShowMode[RatingShowMode["ContentViolation"] = 2] = "ContentViolation";
        RatingShowMode[RatingShowMode["Success"] = 3] = "Success";
        RatingShowMode[RatingShowMode["DeleteSuccess"] = 4] = "DeleteSuccess";
        RatingShowMode[RatingShowMode["WriteNewReview"] = 5] = "WriteNewReview";
        RatingShowMode[RatingShowMode["Loading"] = 6] = "Loading";
        RatingShowMode[RatingShowMode["EnsureDelete"] = 7] = "EnsureDelete";
        RatingShowMode[RatingShowMode["EditReview"] = 8] = "EditReview";
    })(Constants.RatingShowMode || (Constants.RatingShowMode = {}));
    (function(CookieExpiry) {
        CookieExpiry.Default = 13 * 30 * 24 * 60 * 60 * 1000;
        CookieExpiry.Spza = 1000 * 60 * 60 * 24 * 13;
        CookieExpiry.RefreshToken = 1000 * 60 * 60 * 24 * 14;
        CookieExpiry.ExperimentDuration = 1000 * 60 * 60 * 24 * 90;
    })(Constants.CookieExpiry || (Constants.CookieExpiry = {}));
    (function(Reviews) {
        Reviews.CommentsPerPage = 10;
        Reviews.MaxSubsequentDeletedComments = 4;
        Reviews.MaxCommentComposeLength = 500;
        (function(ReviewCommentModalMode) {
            ReviewCommentModalMode[ReviewCommentModalMode["ContentViolation"] = 0] = "ContentViolation";
            ReviewCommentModalMode[ReviewCommentModalMode["ConfirmDelete"] = 1] = "ConfirmDelete";
            ReviewCommentModalMode[ReviewCommentModalMode["DeleteError"] = 2] = "DeleteError";
            ReviewCommentModalMode[ReviewCommentModalMode["ConfirmUpdate"] = 3] = "ConfirmUpdate";
            ReviewCommentModalMode[ReviewCommentModalMode["UpdateError"] = 4] = "UpdateError";
            ReviewCommentModalMode[ReviewCommentModalMode["CreateError"] = 5] = "CreateError";
            ReviewCommentModalMode[ReviewCommentModalMode["Loading"] = 6] = "Loading";
        })(Reviews.ReviewCommentModalMode || (Reviews.ReviewCommentModalMode = {}));
        (function(ReviewCommentActionError) {
            ReviewCommentActionError["ContentViolation"] = "ContentViolation";
        })(Reviews.ReviewCommentActionError || (Reviews.ReviewCommentActionError = {}));
        (function(Microdata) {
            Microdata.AppItemType = 'https://schema.org/SoftwareApplication';
            Microdata.AppCategory = 'UtilitiesApplication';
        })(Reviews.Microdata || (Reviews.Microdata = {}));
        (function(ReviewsSource) {
            ReviewsSource.Internal = 'Internal';
            ReviewsSource.External = 'External';
            ReviewsSource.All = 'All';
        })(Reviews.ReviewsSource || (Reviews.ReviewsSource = {}));
    })(Constants.Reviews || (Constants.Reviews = {}));
    (function(EntityType) {
        EntityType[EntityType["App"] = 1] = "App";
        EntityType[EntityType["Service"] = 2] = "Service";
        EntityType[EntityType["Partner"] = 5] = "Partner";
        EntityType[EntityType["CloudsIndustry"] = 6] = "CloudsIndustry";
    })(Constants.EntityType || (Constants.EntityType = {}));
    Constants.ECAPayloadAction = 'Create';
    (function(Dynamics365LicenseType) {
        Dynamics365LicenseType[Dynamics365LicenseType["dynamics365License"] = 1] = "dynamics365License";
        Dynamics365LicenseType[Dynamics365LicenseType["dynamics365forBusinessLicense"] = 2] = "dynamics365forBusinessLicense";
        Dynamics365LicenseType[Dynamics365LicenseType["noLicense"] = -1] = "noLicense";
    })(Constants.Dynamics365LicenseType || (Constants.Dynamics365LicenseType = {}));
    (function(Dynamics365LicenseIndex) {
        Dynamics365LicenseIndex[Dynamics365LicenseIndex["dynamics365LicenseIndex"] = 0] = "dynamics365LicenseIndex";
        Dynamics365LicenseIndex[Dynamics365LicenseIndex["dynamics365ForBusinessLicenseIndex"] = 1] = "dynamics365ForBusinessLicenseIndex";
    })(Constants.Dynamics365LicenseIndex || (Constants.Dynamics365LicenseIndex = {}));
    (function(SearchBy) {
        SearchBy[SearchBy["Id"] = 0] = "Id";
        SearchBy[SearchBy["Class"] = 1] = "Class";
        SearchBy[SearchBy["Tag"] = 2] = "Tag";
        SearchBy[SearchBy["None"] = 3] = "None";
        SearchBy[SearchBy["QuerySelector"] = 4] = "QuerySelector";
    })(Constants.SearchBy || (Constants.SearchBy = {}));
    (function(SystemKey) {
        SystemKey[SystemKey["Space"] = 32] = "Space";
        SystemKey[SystemKey["Tab"] = 9] = "Tab";
        SystemKey[SystemKey["Enter"] = 13] = "Enter";
        SystemKey[SystemKey["Esc"] = 27] = "Esc";
        SystemKey[SystemKey["Up"] = 38] = "Up";
        SystemKey[SystemKey["Down"] = 40] = "Down";
    })(Constants.SystemKey || (Constants.SystemKey = {}));
    (function(SystemKeyAsString) {
        SystemKeyAsString["Space"] = " ";
        SystemKeyAsString["Tab"] = "Tab";
        SystemKeyAsString["Enter"] = "Enter";
        SystemKeyAsString["Esc"] = "Escape";
        SystemKeyAsString["ArrowUp"] = "ArrowUp";
        SystemKeyAsString["ArrowDown"] = "ArrowDown";
    })(Constants.SystemKeyAsString || (Constants.SystemKeyAsString = {}));
    (function(SystemKeyString) {
        SystemKeyString["Space"] = "Space";
        SystemKeyString["Tab"] = "Tab";
        SystemKeyString["Enter"] = "Enter";
        SystemKeyString["Esc"] = "Esc";
        SystemKeyString["Up"] = "Up";
        SystemKeyString["Down"] = "Down";
    })(Constants.SystemKeyString || (Constants.SystemKeyString = {}));
    (function(Recommendations) {
        Recommendations["WhatsNew"] = "WhatsNew";
        Recommendations["Trending"] = "Trending";
        Recommendations["WhatsNewMicrosoft365"] = "WhatsNewMicrosoft365";
        Recommendations["TrendingMicrosoft365"] = "TrendingMicrosoft365";
    })(Constants.Recommendations || (Constants.Recommendations = {}));
    (function(FieldHubUserType) {
        FieldHubUserType[FieldHubUserType["None"] = 0] = "None";
        FieldHubUserType[FieldHubUserType["Limited"] = 1] = "Limited";
        FieldHubUserType[FieldHubUserType["Full"] = 2] = "Full";
    })(Constants.FieldHubUserType || (Constants.FieldHubUserType = {}));
    (function(VaritionKey) {
        VaritionKey[VaritionKey["Default"] = 0] = "Default";
        VaritionKey[VaritionKey["Treatment"] = 1] = "Treatment";
        VaritionKey[VaritionKey["TreatmentNewFilterAMP"] = 2] = "TreatmentNewFilterAMP";
    })(Constants.VaritionKey || (Constants.VaritionKey = {}));
    (function(TenantType) {
        TenantType[TenantType["None"] = 0] = "None";
        TenantType[TenantType["Viral"] = 1] = "Viral";
        TenantType[TenantType["Managed"] = 2] = "Managed";
        TenantType[TenantType["Msa"] = 3] = "Msa";
        TenantType[TenantType["Unknown"] = 4] = "Unknown";
    })(Constants.TenantType || (Constants.TenantType = {}));
    Constants.InvoiceLink = 'https://aka.ms/appsource/paybyinvoice';
    Constants.AzureSubscriptionLink = 'http://aka.ms/appsource/azuresub';
    Constants.AzureBenefitURL = 'http://aka.ms/appsource/azurebenefit';
    Constants.MicrosoftTermsURL = 'https://aka.ms/azuremarketplaceterms';
    Constants.MyOrdersLink = 'https://admin.microsoft.com/Adminportal/Home#/subscriptions/apps';
    Constants.AdminCenterLink = 'https://admin.microsoft.com/Adminportal/Home';
    Constants.AdminCenterYourProductsLink = 'https://admin.microsoft.com/adminportal/home?#/subscriptions';
    Constants.AdminCenterLicensesLink = 'https://admin.microsoft.com/adminportal/home?#/licenses';
    Constants.MicrosoftPrivacyStatementURL = 'https://aka.ms/AppSourcePrivacyStatement';
    Constants.MicrosoftRatingReviewPolicy = 'https://docs.microsoft.com/en-us/legal/marketplace/rating-review-policies';
    Constants.FeaturedAppsId = '99';
    Constants.InitializationRetryAttempts = process.env.initializationRetryAttempts ? parseInt(process.env.initializationRetryAttempts, 10) : 1;
    Constants.InitializationRetryDelay = process.env.initializationRetryDelay ? parseInt(process.env.initializationRetryDelay, 10) : 1000 * 60 * 5; // 5 minutes
    Constants.MaxItemsPerPageInReviews = 10;
    Constants.mooncakeNationalCloud = 'mooncake';
    Constants.fairfaxNationalCloud = 'fairfax';
    Constants.blackforestNationalCloud = 'blackforest';
    Constants.EmailRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    Constants.LocaleRegex = /^[a-zA-Z- ]*$/;
    Constants.AlphaNumericRegex = /^[a-zA-Z0-9 ]+$/;
    Constants.SeoLocaleRegex = /[/][a-zA-Z]{2}-[a-zA-Z]{2,4}/;
    Constants.removeHtmlRegex = /<(.|\n)*?>/g;
    Constants.crossListingRibbonItemCount = 5;
    Constants.memCacheExpiry = 1200000;
    Constants.testDriveDocumentationLink = 'https://go.microsoft.com/fwlink/?linkid=845086';
    Constants.ampTestDriveDocumentationLink = 'https://azure.microsoft.com/en-us/blog/azure-marketplace-test-drive/';
    Constants.purchaseInAppSourceLink = 'https://aka.ms/AppSourceDocOverview';
    Constants.appSourceContactUsLink = 'https://aka.ms/AppSourceContactUs';
    Constants.GraphResourceUrl = 'https://graph.windows.net';
    Constants.AccessTokenUrl = 'https://login.microsoftonline.com/common/oauth2/token';
    Constants.PowerBIResourceUrl = 'https://analysis.windows.net/powerbi/api';
    Constants.PowerBIVisualInstructionsUrl = 'https://go.microsoft.com/fwlink/?linkid=2161918';
    Constants.learnMoreCertifiedPBI = 'https://aka.ms/power-bi-custom-visuals-certified';
    Constants.learnMoreBillingPane = 'https://aka.ms/appsourcecountries';
    Constants.refreshAccessTokenInterval = 1000 * 60 * 45; // 45 minutes in ms
    Constants.ServicesUserSegment = 'Services';
    Constants.UserSegmentQueryParameter = 'usersegment';
    Constants.InitialStateCacheKey = 'initialState';
    Constants.everywhereFilterView = 'everywhere';
    Constants.URLCacheKeyIsMobileView = 'ismobileview';
    Constants.ABTesting = 'ABTesting';
    Constants.canoninalfilterQuery = 'filters=';
    Constants.canonicalAMPEnvWebAppName = 'mac';
    Constants.canonicalAMPEnvAppName = 'azureMarketPlace';
    Constants.tfsStringFieldMaxLength = 255;
    Constants.mpnIdMaxDigits = 7;
    Constants.enterpriseContractLink = 'https://go.microsoft.com/fwlink/?linkid=2041178';
    Constants.M365Admin = 'M365Admin';
    Constants.PanelWidth = '340px';
    Constants.PrimaryProductBitMaskKey = 'product_mask_1';
    Constants.AppSourceStorefronts = [
        'appsource',
        'teamsadmin',
        'm365admin'
    ];
    Constants.redirectRoute = 'redirect';
    (function(ReviewsEnrichApiResponse) {
        ReviewsEnrichApiResponse.ContentViolation = 'ContentViolation';
        ReviewsEnrichApiResponse.UserDidntPurchase = 'user has not acquired the app';
    })(Constants.ReviewsEnrichApiResponse || (Constants.ReviewsEnrichApiResponse = {}));
    (function(Checkout) {
        Checkout.MaxQuantity = 1000000;
        Checkout.IsSaasBundle = 'isSaaSBundle';
        Checkout.ContentId = 'contentId';
        Checkout.OperationLocation = 'operation-location';
        Checkout.RetryAfter = 'retry-after';
        Checkout.DefaultPlanIdQueryParam = 'defaultPlanId';
        (function(TermId) {
            TermId.Monthly = 'hjdtn7tfnxcy';
            TermId.Yearly = 'nm5o4wf9fbfy';
        })(Checkout.TermId || (Checkout.TermId = {}));
    })(Constants.Checkout || (Constants.Checkout = {}));
    (function(OrderConfirmation) {
        OrderConfirmation.InternalServerErrorLimit = 3;
        OrderConfirmation.PreviewOffer = '-preview';
        OrderConfirmation.OfferNotFoundErrorMessage = 'was not found in the catalog';
        OrderConfirmation.TestHeaderLowerCase = 'test header';
        OrderConfirmation.CustomMetersErrorMessage = 'The purchase has failed because the plan you selected is not available for purchase from AppSource. It is available for purchase in Azure Portal.';
        OrderConfirmation.RiskPrepaidCardErrorReason = 'AzurePrepaidBINPolicy_Reject_Terminate';
    })(Constants.OrderConfirmation || (Constants.OrderConfirmation = {}));
    (function(StatusError) {
        StatusError.Conflict = 409;
        StatusError.InternalServerError = 500;
    })(Constants.StatusError || (Constants.StatusError = {}));
    (function(Cookies) {
        Cookies.AppSourceCookie = 'appsource';
        Cookies.unifiedExperience = 'unifiedExperience';
        Cookies.AppSourceLeadCookie = 'appsourcelead';
        Cookies.LocaleCookie = 'spzaLocale';
        Cookies.billingRegionCookie = 'appsourcebillingregion';
        Cookies.correlationId = 'correlationId';
        Cookies.privacyConsentAcceptedDate = 'privacyConsentAcceptedDate';
        Cookies.WCPBannerName = 'WCPcookieBannerId';
        Cookies.WCPManageCookieBtnId = 'c-uhff-footer_managecookies';
        Cookies.WCPDefaultLocale = 'en-US';
        Cookies.WCPEventName = 'wcpconsent-download-done';
        Cookies.AMC3PAdsOptOut = '3PAdsOptOut';
        (function(Errors) {
            Errors["ParsingExperimentsCookieError"] = "Failed to parse experiments cookie";
            Errors["ParsingVariantsError"] = "Failed to parse variants within experiments cookie";
        })(Cookies.Errors || (Cookies.Errors = {}));
        Cookies.Essential = {
            /** Cookie to track the session, essential for tracking user behavior */ [Constants.Cookies.correlationId]: true,
            [Constants.Cookies.AMC3PAdsOptOut]: true
        };
    })(Constants.Cookies || (Constants.Cookies = {}));
    (function(ConsentAnalyticAssets) {
        ConsentAnalyticAssets["GA"] = "GA";
    })(Constants.ConsentAnalyticAssets || (Constants.ConsentAnalyticAssets = {}));
    (function(Catalog) {
        Catalog.RatingAverageDecimalPoints = 3;
        Catalog.RatingAverageDecimalPointsHelper = Math.pow(10, Catalog.RatingAverageDecimalPoints);
        Catalog.ImageNameUnavailable = 'Unavailable';
        Catalog.DefaultTestDriveVideoName = 'About this test drive';
        Catalog.DefaultTestDriveManual = 'Test drive manual';
        Catalog.DefaultOfficeLocale = 'en';
        Catalog.AllMarkets = 'ALL';
        Catalog.legacyPlanIdARM = '-arm';
        (function(CategoryId) {
            CategoryId["MicrosoftIotEdgeModule"] = "microsoft-iot-edge-module";
        })(Catalog.CategoryId || (Catalog.CategoryId = {}));
        (function(MeterUnit) {
            MeterUnit["HR"] = "HR";
        })(Catalog.MeterUnit || (Catalog.MeterUnit = {}));
        (function(MeterType) {
            MeterType["FreeTrialMeterType"] = "1 Compute Hour - FreeTrial";
        })(Catalog.MeterType || (Catalog.MeterType = {}));
        (function(ArtificatsName) {
            ArtificatsName["DefaultTemplate"] = "DefaultTemplate";
            ArtificatsName["UiDefinition"] = "UiDefinition.json";
            ArtificatsName["CreateUiDefinition"] = "createuidefinition";
        })(Catalog.ArtificatsName || (Catalog.ArtificatsName = {}));
    })(Constants.Catalog || (Constants.Catalog = {}));
    (function(LocalStorage) {
        LocalStorage.spzaUserId = 'spzaUserId';
        LocalStorage.trailId = 'trailId';
        LocalStorage.nps = 'nps';
        LocalStorage.npsNext = 'next';
        LocalStorage.npsNextText = 'nextText';
        LocalStorage.dontShowInstructions = 'dontShowInstructions';
        LocalStorage.LoginHint = 'loginHint';
        LocalStorage.Essentials = [
            Constants.LocalStorage.LoginHint
        ];
    })(Constants.LocalStorage || (Constants.LocalStorage = {}));
    Constants.usCountryCode = 'us';
    Constants.usCountryCodeUpper = Constants.usCountryCode.toUpperCase();
    Constants.caCountryCode = 'ca';
    Constants.auCountryCode = 'au';
    Constants.allCountriesCode = 'ALL';
    Constants.allStatesCode = 'all';
    Constants.allStatesCodeUpper = Constants.allStatesCode.toUpperCase();
    Constants.usdCurrency = 'USD';
    Constants.countryCodeQueryParam = 'country';
    Constants.regionCodeQueryParam = 'region';
    Constants.usFilterText = 'United States';
    Constants.auFilterText = 'Austrilia';
    Constants.allRegionsFilterText = 'All States/Provinces';
    Constants.userAcceptField = 'accepted';
    Constants.userProfileEmbedCookieName = 'userProfileEmbedHost';
    Constants.Country = 'country';
    (function(EventsApi) {
        EventsApi.View = 'view';
        EventsApi.BusinessApplicationsType = 'BusinessApplications';
    })(Constants.EventsApi || (Constants.EventsApi = {}));
    (function(UrlParamCacheKeyWhiteListKey) {
        UrlParamCacheKeyWhiteListKey["Product"] = "product";
        UrlParamCacheKeyWhiteListKey["Service"] = "service";
        UrlParamCacheKeyWhiteListKey["Default"] = "default";
    })(Constants.UrlParamCacheKeyWhiteListKey || (Constants.UrlParamCacheKeyWhiteListKey = {}));
    (function(Search) {
        Search.numberOfTops = 1000;
        Search.searchFullQueryType = 'full';
        Search.maxNumOfSuggestions = 5;
        Search.cloudIndustryCategoriesFilter = 'CloudIndustryCategories/any()';
        Search.maxSearchTextLength = 200;
        (function(SuggestionTypes) {
            SuggestionTypes["WordSearch"] = "WordSearch";
            SuggestionTypes["Entity"] = "Entity";
        })(Search.SuggestionTypes || (Search.SuggestionTypes = {}));
        (function(QueryParams) {
            QueryParams.SuggestionTypes = 'suggestionTypes';
            QueryParams.SearchQuery = 'searchQuery';
            QueryParams.IndustryCloud = 'industryCloud';
            QueryParams.Language = 'language';
            QueryParams.Gallery = 'gallery';
            QueryParams.ProductTypes = 'productTypes';
        })(Search.QueryParams || (Search.QueryParams = {}));
        (function(Endpoints) {
            Endpoints.Search = '/search';
            Endpoints.Suggestions = 'suggestions/products';
        })(Search.Endpoints || (Search.Endpoints = {}));
        (function(ApiVersions) {
            ApiVersions.SearchApiSuggestions = '2022-09-25-preview';
        })(Search.ApiVersions || (Search.ApiVersions = {}));
        (function(SelectEntry) {
            SelectEntry.ApplicationId = 'ApplicationId';
            SelectEntry.ServiceId = 'ServiceId';
        })(Search.SelectEntry || (Search.SelectEntry = {}));
        (function(SearchMode) {
            SearchMode.All = 'all';
        })(Search.SearchMode || (Search.SearchMode = {}));
        (function(ActionType) {
            ActionType["Suggestions"] = "Suggestions";
            ActionType["Search"] = "Search";
        })(Search.ActionType || (Search.ActionType = {}));
        (function(OrderBy) {
            OrderBy["asc"] = "asc";
            OrderBy["desc"] = "desc";
        })(Search.OrderBy || (Search.OrderBy = {}));
    })(Constants.Search || (Constants.Search = {}));
    (function(FilteredGallery) {
        FilteredGallery.pageSize = 60;
        FilteredGallery.officeFilter = 'office';
    })(Constants.FilteredGallery || (Constants.FilteredGallery = {}));
    (function(TileDataEntityType) {
        TileDataEntityType["App"] = "App";
        TileDataEntityType["Service"] = "Service";
        TileDataEntityType["CloudsIndustry"] = "CloudsIndustry";
        TileDataEntityType["All"] = "All";
    })(Constants.TileDataEntityType || (Constants.TileDataEntityType = {}));
    (function(TileDataAdditionalQueryParams) {
        TileDataAdditionalQueryParams["sortBy"] = "sortBy";
        TileDataAdditionalQueryParams["page"] = "page";
        TileDataAdditionalQueryParams["region"] = "region";
        TileDataAdditionalQueryParams["country"] = "country";
        TileDataAdditionalQueryParams["includeTestProducts"] = "includeTestProducts";
    })(Constants.TileDataAdditionalQueryParams || (Constants.TileDataAdditionalQueryParams = {}));
    (function(TileDataFilteredQueryParams) {
        TileDataFilteredQueryParams["search"] = "search";
        TileDataFilteredQueryParams["subcategories"] = "subcategories";
        TileDataFilteredQueryParams["subindustries"] = "subindustries";
        TileDataFilteredQueryParams["filters"] = "filters";
        TileDataFilteredQueryParams["serviceType"] = "serviceType";
    })(Constants.TileDataFilteredQueryParams || (Constants.TileDataFilteredQueryParams = {}));
    (function(TileDataCuratedQueryParams) {
        TileDataCuratedQueryParams["category"] = "category";
        TileDataCuratedQueryParams["industry"] = "industry";
        TileDataCuratedQueryParams["product"] = "product";
    })(Constants.TileDataCuratedQueryParams || (Constants.TileDataCuratedQueryParams = {}));
    (function(DataMapCollectionKeys) {
        DataMapCollectionKeys["categories"] = "categories";
        DataMapCollectionKeys["industries"] = "industries";
        DataMapCollectionKeys["cloudIndustries"] = "cloudIndustries";
        DataMapCollectionKeys["products"] = "products";
        DataMapCollectionKeys["serviceTypes"] = "serviceTypes";
        DataMapCollectionKeys["trials"] = "trials";
        DataMapCollectionKeys["pricingModel"] = "pricingModel";
        DataMapCollectionKeys["ratings"] = "ratings";
        DataMapCollectionKeys["appCompliance"] = "appCompliance";
        DataMapCollectionKeys["azureBenefitEligible"] = "AzureBenefitEligible";
        DataMapCollectionKeys["copilotExtension"] = "CopilotExtension";
        DataMapCollectionKeys["productType"] = "productType";
    })(Constants.DataMapCollectionKeys || (Constants.DataMapCollectionKeys = {}));
    (function(CategoriesDataMapCollectionKeys) {
        CategoriesDataMapCollectionKeys["default"] = "default";
        CategoriesDataMapCollectionKeys["office"] = "office";
        CategoriesDataMapCollectionKeys["powerBiVisuals"] = "powerBiVisuals";
        CategoriesDataMapCollectionKeys["addIns"] = "addIns";
    })(Constants.CategoriesDataMapCollectionKeys || (Constants.CategoriesDataMapCollectionKeys = {}));
    Constants.CuratedQueryParamsToDataMapCollectionKeyMap = {
        ["category"]: "categories",
        ["industry"]: "industries",
        ["product"]: "products"
    };
    Constants.UrlParamCacheKeyWhiteList = {
        country: true,
        region: true,
        tab: true,
        product: true,
        embedhost: true
    };
    Constants.UrlParamCacheKeyBlackList = {
        search: true,
        product: true,
        category: true,
        industry: true,
        subcategories: true,
        subindustries: true,
        filters: true,
        servicetype: true
    };
    Constants.EmbedUrlParamCacheKeyBlackList = _object_spread_props(_object_spread({}, Constants.UrlParamCacheKeyBlackList), {
        product: undefined
    });
    let UserPII = /*#__PURE__*/ function(UserPII) {
        UserPII["firstName"] = "firstName";
        UserPII["lastName"] = "lastName";
        UserPII["email"] = "email";
        UserPII["phone"] = "phone";
        UserPII["oid"] = "oid";
        UserPII["alternateEmail"] = "alternateEmail";
        return UserPII;
    }({});
    Constants.PIIFields = [
        "firstName",
        "lastName",
        "email",
        "phone",
        "oid",
        "alternateEmail"
    ];
    Constants.RawDataCacheKeyPrefix = 'RawData|';
    (function(Headers) {
        Headers.CV = 'ms-cv';
        Headers.RequestId = 'x-ms-requestid';
        Headers.CorrelationId = 'x-ms-correlationid';
        Headers.XMSUserAgent = 'x-ms-useragent';
        Headers.Source = 'x-ms-source';
        Headers.Bearer = 'Bearer '; // Please do not remove the whitespace at the end
        Headers.AccessKey = 'accesskey';
        Headers.Authorization = 'authorization';
        Headers.Referer = 'referer';
        Headers.InternalAuthorizationHeader = 'x-ms-authorization';
        Headers.Cookie = 'cookie';
        Headers.Host = 'host';
        Headers.iframeOptions = 'X-Frame-Options';
        Headers.ContentType = 'Content-Type';
        Headers.UserAgent = 'user-agent';
        Headers.XMSSourceAppSource = 'AppSource';
        Headers.XMSSourceAMP = 'AzureMarketplace';
        Headers.XMSClientName = 'x-ms-client-name';
        Headers.XForwardedFor = 'x-forwarded-for';
        Headers.XIISNodeRemoteAddr = 'x-iisnode-remote_addr';
        Headers.AcceptLanguages = 'accept-language';
        Headers.ApplicationType = 'x-ms-applicationType';
        Headers.CatalogApiClientRequestId = 'x-ms-client-request-id';
        Headers.ETag = 'ETag';
        Headers.CacheControl = 'Cache-Control';
        Headers.Pragma = 'Pragma';
        Headers.Expires = 'Expires';
        Headers.ApiKey = 'api-key';
        Headers.Origin = 'Origin';
        Headers.Accept = 'accept';
        Headers.XMsApp = 'x-ms-app';
        Headers.SetCookie = 'set-cookie';
        Headers.XMSAuthInternalToken = 'x-ms-auth-internal-token';
        Headers.XAPIKey = 'X-API-Key';
        Headers.XProofToken = 'x-proof-token';
        Headers.ProxyAuthorization = 'proxy-authorization';
        Headers.XMSClientObjectId = 'x-ms-client-object-id';
        Headers.XMSClientTenantId = 'x-ms-client-tenant-id';
        Headers.XMSClientRegion = 'x-ms-client-region';
    })(Constants.Headers || (Constants.Headers = {}));
    (function(OperationNames) {
        OperationNames.PassThroughLog = 'PassThroughLog ';
        OperationNames.PostTokens = 'Post Tokens';
        OperationNames.Server = 'Server';
        OperationNames.Request = 'Request';
        OperationNames.PreRequest = 'Potential AAD Callback Request';
        OperationNames.RateLimit = 'Rate Limit';
        OperationNames.TokenLog = 'Token Log';
        OperationNames.ParamsValidation = 'params Validation';
        OperationNames.MainRequest = 'Request Received';
        OperationNames.EnsureAsyncData = 'Ensure Async Data';
        OperationNames.GetHeaderData = 'Get Header Data';
        OperationNames.RenderReactApp = 'Render React App';
        OperationNames.WarmupRemoteModulesRendering = 'Warmup Remote Modules Rendering';
        OperationNames.FulFillRequest = 'Ful Fill Request';
        OperationNames.ProcessReduxStore = 'Process Redux Store';
        OperationNames.PreSSRPromises = 'Pre SSR Promises';
        OperationNames.SSRRequest = 'SSR Request';
        OperationNames.Embed = 'Embed';
        OperationNames.Signin = 'Signin';
        OperationNames.Signout = 'Logout';
        OperationNames.AADCallback = 'AAD Callback Request';
        OperationNames.LeadGen = 'LeadGeneration';
        OperationNames.SaveLeadGenSettings = 'SaveLeadGenSettings';
        OperationNames.SolutionsTestDriveAcquisition = 'Solutions Test Drive Acquisition';
        OperationNames.SolutionsInstanceStatus = 'Solutions Instance Status';
        OperationNames.SolutionsInstanceAction = 'Solutions Instance Action';
        OperationNames.AmpTestDriveAcquisition = 'AmpTestDriveAcquisition';
        OperationNames.AmpSolutionsInstanceStatus = 'AmpSolutionsInstanceStatusProcessor';
        OperationNames.AmpSolutionsInstanceAction = 'AmpSolutionsInstanceAction';
        OperationNames.AutoSignin = 'Auto Signin';
        OperationNames.Acquisition = 'Acquisition';
        OperationNames.LogCreateLeadPayload = 'LogCreateLeadPayload';
        OperationNames.LogAcquisitionPayload = 'LogAcquisitionPayload';
        OperationNames.UserAgent = 'User Agent';
        OperationNames.ObtainAccessToken = 'Obtain Access Token';
        OperationNames.CreateUser = 'create User';
        OperationNames.MsalGetTokenOnBehalf = 'msal.getTokenOnBehalf';
        OperationNames.SearchApi = 'searchRestClient.callSearch';
        OperationNames.SearchApiRemovedOffers = 'searchRestClient.callSearch.removedOffers';
        OperationNames.MarkoApi = 'searchRestClient.callMarkoSearch';
        OperationNames.CombinedSearch = 'searchRestClient.callSearchWithMarko';
        OperationNames.GetRefreshTokenFromCache = 'GetRefreshTokenFromCache';
    })(Constants.OperationNames || (Constants.OperationNames = {}));
    (function(CacheStatus) {
        CacheStatus["Healthy"] = "Healthy";
        CacheStatus["Unhealthy"] = "Unhealthy";
    })(Constants.CacheStatus || (Constants.CacheStatus = {}));
    (function(BrowserConfigs) {
        BrowserConfigs["appsource"] = "appsource";
        BrowserConfigs["azureMarketPlace"] = "azureMarketPlace";
        BrowserConfigs["embed"] = "embed";
    })(Constants.BrowserConfigs || (Constants.BrowserConfigs = {}));
    (function(ClientNames) {
        ClientNames["AppSource"] = "AppSource";
        ClientNames["AMP"] = "AMP";
        ClientNames["Embedded"] = "Embedded";
        ClientNames["Default"] = "";
    })(Constants.ClientNames || (Constants.ClientNames = {}));
    (function(AppConfig) {
        AppConfig["correlationId"] = "correlationId";
    })(Constants.AppConfig || (Constants.AppConfig = {}));
    Constants.browserConfigsToClientNames = {
        ["appsource"]: "AppSource",
        ["azureMarketPlace"]: "AMP",
        ["embed"]: "Embedded"
    };
    (function(HttpMessage) {
        HttpMessage.InvalidQueryParams = 'Invalid query parameters';
        HttpMessage.OneOrMoreErrors = 'One or more errors occured';
        HttpMessage.Forbidden = 'Forbidden';
        HttpMessage.NotFound = 'Not Found';
        HttpMessage.InternalServerError = 'Internal Server Error';
        HttpMessage.BadRequest = 'BadRequest';
        HttpMessage.AccessKeyExpired = 'Access key expired';
        HttpMessage.AccessKeyInvalid = 'Invalid access key, invalid cipher: Message integrity check failed';
    })(Constants.HttpMessage || (Constants.HttpMessage = {}));
    (function(ControllerOperations) {
        ControllerOperations.ValidateQueryParams = 'Validation of query parameters';
        ControllerOperations.ValidatePayload = 'Validation of payload';
        ControllerOperations.GenerateLead = 'Generation of lead';
        ControllerOperations.SaveLeadSettings = 'Saving lead settings';
        ControllerOperations.AuthoriseRequest = 'Authorization of request';
    })(Constants.ControllerOperations || (Constants.ControllerOperations = {}));
    (function(QueryStrings) {
        QueryStrings.isConverged = 'isConverged';
        QueryStrings.includeStopSoldPlans = 'includeStopSoldPlans';
        QueryStrings.CorrelationId = 'correlationId';
        QueryStrings.Referer = 'referer';
        QueryStrings.ApplicationId = 'appId';
        QueryStrings.PartnerId = 'partnerId';
        QueryStrings.Product = 'product';
        QueryStrings.PlanId = 'planId';
        QueryStrings.DemoId = 'demoId';
        QueryStrings.LabId = 'labId';
        QueryStrings.PublisherId = 'publisherId';
        QueryStrings.DemoSessionId = 'demoSessionId';
        QueryStrings.UrlQuery = 'urlQuery';
        QueryStrings.flightCodes = 'flightCodes';
        QueryStrings.flightCode = 'flightCode';
        QueryStrings.locale = 'locale';
        QueryStrings.tab = 'tab';
        QueryStrings.region = 'region';
        QueryStrings.billingRegion = 'billingregion';
        QueryStrings.entityType = 'entityType';
        QueryStrings.modalAppId = 'modalAppId';
        QueryStrings.modalECAId = 'modalECAId';
        QueryStrings.signInModalType = 'signInModalType';
        QueryStrings.productId = 'productId';
        QueryStrings.modalServiceId = 'modalServiceId';
        QueryStrings.modalReviewId = 'modalReviewId';
        QueryStrings.modalReviewAppId = 'modalReviewAppId';
        QueryStrings.modalReviewTitle = 'modalReviewTitle';
        QueryStrings.country = 'country';
        QueryStrings.ctaType = 'ctaType';
        QueryStrings.ete = 'ete';
        QueryStrings.apiVersion = 'api-version';
        QueryStrings.version = 'version';
        QueryStrings.showAllApps = 'showAllApps';
        QueryStrings.applicationType = 'applicationType';
        QueryStrings.modalRatingId = 'modalRatingId';
        QueryStrings.extraData = 'extraData';
        QueryStrings.embedHost = 'embedHost';
        QueryStrings.includeTestProducts = 'includeTestProducts';
        QueryStrings.isEmbedded = 'isEmbedded';
        QueryStrings.search = 'search';
        QueryStrings.industry = 'industry';
        QueryStrings.serviceType = 'serviceType';
        QueryStrings.category = 'category';
        QueryStrings.product = 'product';
        QueryStrings.page = 'page';
        QueryStrings.certification = 'certification';
        QueryStrings.UseSecondarySearch = 'UseSecondarySearch';
        QueryStrings.market = 'market';
        QueryStrings.productsFlow = 'productsFlow';
        QueryStrings.ExcludePublic = 'excludePublic';
        QueryStrings.hideKeys = 'HideKeys';
        QueryStrings.searchLocale = 'searchLocale';
        QueryStrings.searchQuery = 'searchQuery';
        QueryStrings.filter = '$filter';
        QueryStrings.skiptoken = '$skiptoken';
        QueryStrings.storefront = 'storefront';
        QueryStrings.HideKeys = 'HideKeys[]';
        QueryStrings.includePrivateOffers = 'includePrivateOffers';
        QueryStrings.expand = '$expand';
        (function(Auth) {
            Auth.HOST_NAME = 'hostName';
            Auth.LOGIN_TYPE = 'loginType';
            Auth.MSAL_USER_HOME_ID = 'msalUserHomeId';
            Auth.FROM = 'from';
            Auth.REFRESH_TOKEN = 'refreshToken';
        })(QueryStrings.Auth || (QueryStrings.Auth = {}));
    })(Constants.QueryStrings || (Constants.QueryStrings = {}));
    (function(Curated) {
        Curated.top = 'top';
        Curated.everything = 'everything';
        Curated.office365 = 'Office365';
        Curated.dynamics365 = 'Dynamics 365';
        Curated.powerPlatform = 'PowerPlatform';
        Curated.powerBi = 'Power BI';
    })(Constants.Curated || (Constants.Curated = {}));
    (function(AppActionTypes) {
        AppActionTypes.GET = 'GET';
        AppActionTypes.CREATE = 'CREATE';
        AppActionTypes.FREE = 'FREE';
        AppActionTypes.TRIAL = 'TRIAL';
        AppActionTypes.REQUESTFORTRIAL = 'REQUESTFORTRIAL';
    })(Constants.AppActionTypes || (Constants.AppActionTypes = {}));
    (function(ActionStrings) {
        ActionStrings.Get = 'CTA_Get';
        ActionStrings.Try = 'CTA_Try';
        ActionStrings.RequestTrial = 'CTA_ContactMe';
        ActionStrings.Contact = 'Contact';
        ActionStrings.TestDrive = 'CTA_TestDrive';
        ActionStrings.Service = 'Inquire';
        ActionStrings.Purchase = 'CTA_Get';
        ActionStrings.Select = 'Select';
        ActionStrings.Add = 'CTA_Add';
        ActionStrings.BuyLicense = 'CTA_BuyLicense';
        ActionStrings.Install = 'CTA_Install';
    })(Constants.ActionStrings || (Constants.ActionStrings = {}));
    (function(NpsActions) {
        NpsActions["pdpViewsCount"] = "pdpViewsCount";
        NpsActions["searchActionsCount"] = "pdpViewsCount";
        NpsActions["filterActionsCount"] = "filterActionsCount";
        NpsActions["galleryChangesCount"] = "galleryChangesCount";
        NpsActions["categoryChangesCount"] = "categoryChangesCount";
        NpsActions["paginationActionsCount"] = "paginationActionsCount";
        NpsActions["seeAllActionsCount"] = "seeAllActionsCount";
    })(Constants.NpsActions || (Constants.NpsActions = {}));
    (function(BadgeType) {
        BadgeType["OfficeAwards"] = "OfficeAwards";
        BadgeType["SolutionMap"] = "SolutionMap";
        BadgeType["PBICertified"] = "PBICertified";
        BadgeType["FreeTrial"] = "FreeTrial";
        BadgeType["AzureExpertsMSP"] = "AzureExpertsMSP";
        BadgeType["MicrosoftCertified"] = "MicrosoftCertified";
        BadgeType["SelfAttested"] = "SelfAttested";
        BadgeType["PrivateOffer"] = "PrivateOffer";
        BadgeType["IntegratedSolution"] = "IntegratedSolution";
        BadgeType["AzureBenefitEligible"] = "AzureBenefitEligible";
        BadgeType["CertifiedSoftware"] = "CertifiedSoftware";
        BadgeType["PreferredSolution"] = "PreferredSolution";
        BadgeType["Microsoft365AppAward"] = "Microsoft365AppAward";
    })(Constants.BadgeType || (Constants.BadgeType = {}));
    (function(ButtonType) {
        ButtonType["Link"] = "link";
        ButtonType["Label"] = "label";
    })(Constants.ButtonType || (Constants.ButtonType = {}));
    (function(CTAType) {
        CTAType[CTAType["Get"] = 1] = "Get";
        CTAType[CTAType["Try"] = 2] = "Try";
        CTAType[CTAType["RequestTrial"] = 3] = "RequestTrial";
        CTAType[CTAType["Contact"] = 4] = "Contact";
        CTAType[CTAType["TestDrive"] = 5] = "TestDrive";
        CTAType[CTAType["Service"] = 6] = "Service";
        CTAType[CTAType["Purchase"] = 7] = "Purchase";
        CTAType[CTAType["Select"] = 8] = "Select";
        CTAType[CTAType["AlreadyPurchased"] = 9] = "AlreadyPurchased";
        CTAType[CTAType["Partner"] = 10] = "Partner";
        CTAType[CTAType["DownloadSample"] = 11] = "DownloadSample";
        CTAType[CTAType["Add"] = 12] = "Add";
        CTAType[CTAType["BuyLicense"] = 13] = "BuyLicense";
        CTAType[CTAType["Install"] = 14] = "Install";
    })(Constants.CTAType || (Constants.CTAType = {}));
    (function(CertificationType) {
        CertificationType["Undefined"] = "Undefined";
        CertificationType["None"] = "None";
        CertificationType["SelfAttested"] = "SelfAttested";
        CertificationType["MicrosoftCertified"] = "MicrosoftCertified";
    })(Constants.CertificationType || (Constants.CertificationType = {}));
    (function(currentView) {
        currentView["AppDetails"] = "appDetails";
        currentView["AppGallery"] = "curated appGallery";
        currentView["SearchAppGallery"] = "search filtered appGallery";
    })(Constants.currentView || (Constants.currentView = {}));
    (function(SignInType) {
        SignInType[SignInType["OldSignInModal"] = 0] = "OldSignInModal";
        SignInType[SignInType["SignInWith_MSA_AAD"] = 1] = "SignInWith_MSA_AAD";
        SignInType[SignInType["SignInWith_AAD"] = 2] = "SignInWith_AAD";
        SignInType[SignInType["SignInWith_MSA"] = 3] = "SignInWith_MSA";
        SignInType[SignInType["SwitchTo_AAD"] = 4] = "SwitchTo_AAD";
        SignInType[SignInType["SwitchTo_MSA"] = 5] = "SwitchTo_MSA";
        SignInType[SignInType["Authorized"] = 6] = "Authorized";
    })(Constants.SignInType || (Constants.SignInType = {}));
    (function(SignInRedirect) {
        SignInRedirect.App = 'app';
        SignInRedirect.Service = 'service';
        SignInRedirect.ECA = 'eca';
        SignInRedirect.Review = 'review';
        SignInRedirect.Report = 'reportAbuse';
        SignInRedirect.Checkout = 'checkout';
    })(Constants.SignInRedirect || (Constants.SignInRedirect = {}));
    (function(ActionCodes) {
        ActionCodes.RequestTrial = 'PLT';
        ActionCodes.TryGet = 'INS';
        ActionCodes.Contact = 'CTT';
        ActionCodes.CrossListingContact = 'DNC';
        ActionCodes.TestDrive = 'StartTestDrive';
        ActionCodes.ConsultingServices = 'CSC';
    })(Constants.ActionCodes || (Constants.ActionCodes = {}));
    Constants.TestDriveOfferIdVersion = '0.1';
    (function(ModalType) {
        ModalType[ModalType["NoModalShow"] = 0] = "NoModalShow";
        ModalType[ModalType["SignIn"] = 1] = "SignIn";
        ModalType[ModalType["SignOut"] = 2] = "SignOut";
        ModalType[ModalType["CTA"] = 3] = "CTA";
        ModalType[ModalType["Contact"] = 4] = "Contact";
        ModalType[ModalType["Image"] = 5] = "Image";
        ModalType[ModalType["Video"] = 6] = "Video";
        ModalType[ModalType["MediaModal"] = 7] = "MediaModal";
        ModalType[ModalType["NPS"] = 8] = "NPS";
        ModalType[ModalType["Rating"] = 9] = "Rating";
        ModalType[ModalType["Error"] = 10] = "Error";
        ModalType[ModalType["Drive"] = 11] = "Drive";
        ModalType[ModalType["Iframe"] = 12] = "Iframe";
        ModalType[ModalType["Disclaimer"] = 13] = "Disclaimer";
        ModalType[ModalType["Animation"] = 14] = "Animation";
        ModalType[ModalType["ReportAbuse"] = 15] = "ReportAbuse";
        ModalType[ModalType["Instructions"] = 16] = "Instructions";
        ModalType[ModalType["DownloadSample"] = 17] = "DownloadSample";
        ModalType[ModalType["ReviewComment"] = 18] = "ReviewComment";
        ModalType[ModalType["ReviewMarkAsHelpful"] = 19] = "ReviewMarkAsHelpful";
    })(Constants.ModalType || (Constants.ModalType = {}));
    (function(dynamicsLicense) {
        dynamicsLicense.dynamics365License = 'Dynamics 365';
        dynamicsLicense.dynamics365FinancialLicense = 'Dynamics 365 for Financials';
        dynamicsLicense.noLicense = 'No License';
        dynamicsLicense.currentD365LicenseNumber = 2;
    })(Constants.dynamicsLicense || (Constants.dynamicsLicense = {}));
    Constants.adminPortal = 'admin-portal';
    Constants.adminPortalBackendKey = 'Admin Portal';
    Constants.officeBackendKey = 'Office 365';
    Constants.officeFlatBackendKey = 'Office365';
    (function(dynamics365) {
        dynamics365.dynamics365 = 'dynamics-365';
        dynamics365.operationsED = 'dynamics-365-for-operations';
        dynamics365.financeED = 'dynamics-365-for-finance-and-operations';
        dynamics365.salesED = 'dynamics-365-for-sales';
        dynamics365.fieldServicesED = 'dynamics-365-for-field-services';
        dynamics365.serviceAutomationED = 'dynamics-365-for-project-service-automation';
        dynamics365.customerServiceED = 'dynamics-365-for-customer-services';
        dynamics365.customerInsightsED = 'dynamics-365-customer-insights';
        dynamics365.financeAndOperationsBD = 'dynamics-365-business-central';
        dynamics365.marketingED = 'dynamics-365-marketing';
        dynamics365.commerceED = 'dynamics-365-commerce';
        dynamics365.supplyChainManagementED = 'dynamics-365-supply-chain-management';
    })(Constants.dynamics365 || (Constants.dynamics365 = {}));
    (function(PowerBI) {
        PowerBI.powerBi = 'power-bi';
        PowerBI.visuals = 'power-bi-visuals';
    })(Constants.PowerBI || (Constants.PowerBI = {}));
    (function(InternetOfThings) {
        InternetOfThings.urlKey = 'internet-of-things';
    })(Constants.InternetOfThings || (Constants.InternetOfThings = {}));
    (function(filterTileTypes) {
        filterTileTypes["search"] = "search";
        filterTileTypes["product"] = "product";
        filterTileTypes["industry"] = "industry";
        filterTileTypes["category"] = "category";
        filterTileTypes["serviceType"] = "serviceType";
    })(Constants.filterTileTypes || (Constants.filterTileTypes = {}));
    (function(filterMaps) {
        filterMaps["products"] = "products";
        filterMaps["industries"] = "industries";
        filterMaps["categories"] = "categories";
        filterMaps["serviceTypes"] = "serviceTypes";
    })(Constants.filterMaps || (Constants.filterMaps = {}));
    (function(embedMessage) {
        embedMessage.refreshToken = 'refreshToken';
        embedMessage.loadMarketplaceV2 = 'loadMarketplaceV2';
        embedMessage.loadMarketplace = 'loadMarketplace';
        embedMessage.renewToken = 'renewToken';
    })(Constants.embedMessage || (Constants.embedMessage = {}));
    (function(Avert) {
        Avert.ReportAbuseCategories = [
            {
                locKey: 'ReportModal_None_Label',
                dropDownValue: 'None',
                avertIdentifier: 'None'
            },
            {
                locKey: 'ReportModal_OffensiveContent_Label',
                dropDownValue: 'OffensiveContent',
                avertIdentifier: 'OffensiveContent'
            },
            {
                locKey: 'ReportModal_SpamAndAdvertising_Label',
                dropDownValue: 'SpamAndAdvertising',
                avertIdentifier: 'Other'
            },
            {
                locKey: 'ReportModal_InvalidReview_Label',
                dropDownValue: 'InvalidReview',
                avertIdentifier: 'InvalidReview'
            },
            {
                locKey: 'ReportModal_Other_Label',
                dropDownValue: 'Other',
                avertIdentifier: 'Other'
            }
        ];
    })(Constants.Avert || (Constants.Avert = {}));
    (function(TeachingBubblePurchaseConfirmation) {
        TeachingBubblePurchaseConfirmation.AdminCenterLinkId = 'adminCenter';
        TeachingBubblePurchaseConfirmation.AdminCenterLinkName = 'Admin center link teaching bubble';
        TeachingBubblePurchaseConfirmation.AdminCenterYourProductsLinkId = 'adminCenterYourProducts';
        TeachingBubblePurchaseConfirmation.AdminCenterYourProductsLinkName = 'Admin center your products link teaching bubble';
        TeachingBubblePurchaseConfirmation.AdminCenterLicensesLinkId = 'adminCenterLicenses';
        TeachingBubblePurchaseConfirmation.AdminCenterLicensesLinkName = 'Admin center licenses link teaching bubble';
    })(Constants.TeachingBubblePurchaseConfirmation || (Constants.TeachingBubblePurchaseConfirmation = {}));
    (function(RequestsMethods) {
        RequestsMethods["GET"] = "GET";
        RequestsMethods["POST"] = "POST";
        RequestsMethods["PUT"] = "PUT";
        RequestsMethods["PATCH"] = "PATCH";
        RequestsMethods["DELETE"] = "DELETE";
        RequestsMethods["OPTIONS"] = "OPTIONS";
        RequestsMethods["HEAD"] = "HEAD";
    })(Constants.RequestsMethods || (Constants.RequestsMethods = {}));
    (function(SearchSources) {
        SearchSources["Search"] = "Search";
        SearchSources["Marko"] = "Marko";
        SearchSources["SearchApi"] = "SearchApi";
    })(Constants.SearchSources || (Constants.SearchSources = {}));
    (function(LeadCategory) {
        LeadCategory["Public"] = "public";
        LeadCategory["Private"] = "private";
    })(Constants.LeadCategory || (Constants.LeadCategory = {}));
    Constants.LeadSource = {
        SPZA: 'SPZA',
        D365BusinessCentral: 'D365BusinessCentral',
        D365Sales: 'D365Sales',
        Office: 'Office',
        PowerBI: 'PowerBI'
    };
    Constants.LeadSubSource = {
        InClient: 'InClient',
        Admin: 'Admin',
        Web: 'Web'
    };
    (function(Telemetry) {
        (function(Action) {
            Action.EmbedMessaging = 'Embed Messaging';
            Action.Country = 'Country';
            Action.Click = 'Click';
            Action.Skip = 'Skip';
            Action.VariantAssignment = 'VariantAssignment';
            Action.Search = 'Search';
            Action.MarkoSearchTestTraffic = 'Marko Search Test Traffic';
            Action.NewSearchApi = 'New Search Api';
            Action.ACS = 'ACS';
            Action.SortingSearch = 'SortingSearch';
            Action.Landing = 'Landing';
            Action.PageLoad = 'Page Load';
            Action.openInNewWindow = 'Open In New Window';
            Action.PerfResources = 'Perf resources';
            Action.EmbedMessageListener = 'Embed Message Listener';
            Action.NetworkCall = 'Network Call';
            Action.FilterClick = 'Filter Click';
            Action.FilterExpand = 'Filter Expand';
            Action.FilterChange = 'Filter Change';
            Action.FilterSearchChange = 'Filter Search Change';
            Action.NotifyResult = 'Notify Result';
            Action.ImageLoad = 'Image Load';
            Action.RefreshToken = 'Refresh Token';
            Action.ErrorModal = 'Error Modal';
            Action.MyOrgApps = 'My Org Apps';
            Action.PublishAcquisitionInfo = 'Publish AcquisitionInfo';
            Action.Check = 'Check';
            Action.Uncheck = 'Uncheck';
            Action.CreateUserFromToken = 'createUserFromToken';
            Action.SpzaUserId = 'spzaUserId';
            Action.GoogleId = 'googleClientId';
            Action.UserSettings = 'User Settings';
            Action.UserTenantInfo = 'User Tenant Info';
            Action.PerfEvents = 'Perf Telemetry Events';
            Action.NPS = 'NPS';
            Action.Feedback = 'Feedback';
            Action.FieldHub = 'FieldHub';
            Action.CrossListingInfo = 'Cross Listing Info';
            Action.EnableFeature = 'EnableFeature';
            Action.ClientLocation = 'ClientLocation';
            Action.Open = 'Open';
            Action.Close = 'Close';
            Action.Cancel = 'Cancel';
            Action.Expand = 'Expand';
            Action.Collapse = 'Collapse';
            Action.ReadAccess = 'Read Access';
            Action.WriteAccess = 'Write Access';
            Action.Copy = 'Copy';
            Action.Upsert = 'Upsert';
            Action.Delete = 'Delete';
            Action.Redirecting = 'Redirecting';
            Action.Submitting = 'Submitting';
            Action.Submitted = 'Submitted';
            Action.TileData = 'Tile Data';
            Action.MarkoSearch = 'Marko Search';
            Action.SearchCombinedResults = 'search combined results';
            Action.Error = 'Error';
            Action.SubmitError = 'Submit Error';
            Action.SessionError = 'Session Error';
            Action.LocalStorage = 'LocalStorage';
            Action.Hover = 'Hover';
            Action.ConsentBanner = 'ConsentBanner';
            Action.RouteChanged = 'Route Changed';
            Action.GetTenantType = 'Get Tenant Type';
            Action.GetTenantDetails = 'Get Tenant Details';
            Action.GetUserTenantInfo = "Get user's tenant info";
            Action.GetProduct = 'Get product';
            Action.GetPreviewProduct = 'GetPreviewProduct';
            Action.GetAppSuggestedItems = 'Get Suggested App Items';
            Action.GetAppRecommendedItems = 'Get Recommended App Items';
            Action.GetServiceRecommendedItems = 'Get Recommended Service Items';
            Action.GetPrivateOffers = 'Get Private Offers API';
            Action.GetPrivateOffer = 'Get Private Offer by ID API';
            Action.GetServiceSuggestedItems = 'Get Suggested Service Items';
            Action.EnsureAppDetailsData = 'Ensure App Details Data';
            Action.EnsureAppReviewsData = 'Ensure App Reviews Data';
            Action.EnsureServiceDetailsData = 'Ensure Service Details Data';
            Action.DeleteUserFavourite = 'Delete User Favourite';
            Action.UpsertUserFavourite = 'Upsert User Favourite';
            Action.FetchUserFavourites = 'Fetch User Favourites';
            Action.InputValidations = 'Inputs validations';
            Action.PartnerMessageListener = 'Partners Message Listener';
            Action.PartnerMessageSender = 'Partners Message Sender';
            Action.getUserBillingAccounts = 'get User BillingAccounts';
            Action.getUserProfile = 'get User Profile';
            Action.AssignFlight = 'Assign Flight';
            Action.OldCheckout = 'OldCheckout';
            Action.PlaceOrder = 'Place order';
            Action.Checkout = 'Checkout';
            Action.Purchase = 'Purchase';
            Action.PreWarm = 'PreWarm';
            Action.PreWarmAJAX = 'PreWarmAJAX';
            Action.TrailData = 'Trail Data';
            Action.RootHandler = 'Root Handler';
            Action.LongTermSaaS = 'LongTermSaaS';
            Action.PerfTiming = 'Perf timing';
            Action.PerfRedirect = 'Perf redirect';
            Action.PerfFetchStart = 'Perf fetch start';
            Action.PerfRequestStart = 'Perf request start';
            Action.PerfResponseStart = 'Perf response start';
            Action.PerfResponseEnd = 'Perf response end';
            Action.PerfDOMLoading = 'Perf DOM loading';
            Action.PerfDOMInteractive = 'Perf DOM interactive';
            Action.PerfDOMContentLoaded = 'Perf DOM content loaded';
            Action.Logout = 'Logout';
            Action.Login = 'Login';
            Action.LoginIframe = 'Login Iframe';
            Action.CVA = 'CVA';
            Action.TeachingBubble = 'Teaching bubble';
            Action.EmbedBuyLicenseClick = 'Embed Buy License Click';
            Action.EmbedInstallClick = 'Embed Install Click';
            Action.RemoteStatus = 'RemoteStatus';
            Action.SendLead = 'SendLead';
            Action.SendLeadInfo = 'SendLeadInfo';
            Action.GetLeadActionCode = 'GetLeadActionCode';
            Action.ProcessLeadInfo = 'ProcessLeadInfo';
            Action.GetCustomers = 'getCustomers';
        })(Telemetry.Action || (Telemetry.Action = {}));
        (function(ActionModifier) {
            ActionModifier.ReceiveMessage = 'Receive Message';
            ActionModifier.CloseAuth = 'close_auth';
            ActionModifier.PaymentLoaded = 'Payment Loaded';
            ActionModifier.SaasLinkTooltip = 'saaslinking tooltip';
            ActionModifier.SaaSLinkingTile = 'saaslinking tile';
            ActionModifier.RedirectButton = 'RedirectButton';
            ActionModifier.RedirectModal = 'RedirectModal';
            ActionModifier.FlagClicked = 'Country clicked';
            ActionModifier.FooterLocale = 'Footer locale';
            ActionModifier.CountryModal = 'Country modal';
            ActionModifier.SearchV1End = 'SearchV1End';
            ActionModifier.UserType = 'User Type';
            ActionModifier.AdminCenter = 'Admin Center';
            ActionModifier.AdminCenterYourProducts = 'Admin Center Your Products';
            ActionModifier.AdminCenterLicenses = 'Admin Center Licenses';
            ActionModifier.Start = 'Start';
            ActionModifier.InProgress = 'InProgress';
            ActionModifier.End = 'End';
            ActionModifier.Abandon = 'Abandon';
            ActionModifier.Skip = 'Skip';
            ActionModifier.StartBack = 'StartBack';
            ActionModifier.Error = 'Error';
            ActionModifier.Info = 'Info';
            ActionModifier.RRSubmit = 'R&R';
            ActionModifier.RRDelete = 'R&R Delete';
            ActionModifier.Link = 'Link';
            ActionModifier.Tab = 'Tab';
            ActionModifier.Debug = 'Debug';
            ActionModifier.Exception = 'Exception';
            ActionModifier.Warning = 'Warning';
            ActionModifier.Declined = 'Declined';
            ActionModifier.ConsentModal = 'Consent Modal Dialog';
            ActionModifier.LoginModal = 'Login Modal';
            ActionModifier.MyOrders = 'My Orders';
            ActionModifier.Signup = 'Signup';
            ActionModifier.ChangeCheckoutView = 'Change checkout view';
            ActionModifier.CrossListingContact = 'Cross Listing Contact';
            ActionModifier.SubmitLeadGen = 'Submit Lead Gen';
            ActionModifier.AppSearchSuggestions = 'App Search Suggestions';
            ActionModifier.ServiceSearchSuggestions = 'Consulting Service Search Suggestions';
            ActionModifier.ECASearchSuggestions = 'ECA Offer Search Suggestions';
            ActionModifier.AppSearchForAll = 'App Search For All';
            ActionModifier.ServicesSearchForAll = 'Consulting Services Search For All';
            ActionModifier.CloudsIndustrySearchForAll = 'Industry Clouds Search For All';
            ActionModifier.ParnerSearchAll = 'Partners Search For All';
            ActionModifier.ECASearchForAll = 'ECA Offers Search For All';
            ActionModifier.SearchReturned = 'Search Returned From Server';
            ActionModifier.TrailIdUpdate = 'TrailId update';
            ActionModifier.TrailIdValid = 'TrailId valid';
            ActionModifier.HeaderFromUrl = 'HeaderFromUrl';
            ActionModifier.HeaderFromCookie = 'HeaderFromCookie';
            ActionModifier.SpzaUserIdNew = 'New User';
            ActionModifier.SpzaUserIdReturn = 'Returning User';
            ActionModifier.Tile = 'Tile';
            ActionModifier.CookieData = 'CookieData';
            ActionModifier.BillingCountry = 'Billing Country';
            ActionModifier.ChooseSKU = 'Choose SKU';
            ActionModifier.OfferUnavailableInRegion = 'Offer Unavailable in Region';
            ActionModifier.DownloadCSV = 'Download CSV';
            ActionModifier.DownloadPBIVisual = 'Download Power BI Visual';
            ActionModifier.DownloadPBIVisualSample = 'Download Power BI Visual Sample';
            ActionModifier.VMFilter = 'VM Filter';
            ActionModifier.TestDrive = 'Test Drive';
            ActionModifier.AzureTestDrive = 'Azure Test Drive';
            ActionModifier.NavigatingToTestDrive = 'Navigating to test drive';
            ActionModifier.TestDriveDismissed = 'Test Drive Dismissed';
            ActionModifier.FilterClear = 'Filter Clear';
            ActionModifier.FilterPane = 'Filter Pane';
            ActionModifier.FilterTag = 'Filter Tag';
            ActionModifier.Feedback = 'feedback';
            ActionModifier.FeedbackModal = 'feedbackModal';
            ActionModifier.ShowingResultsForFeedback = 'ShowingResultsFor feedback';
            ActionModifier.Breadcrumb = 'Breadcrumb';
            ActionModifier.Results = 'Results';
            ActionModifier.FirstPartyAppPromotion = 'First Party App Promotion';
            ActionModifier.CTAInfo = 'CTA Info';
            ActionModifier.ResetFilters = 'Reset Filters';
            ActionModifier.GoogleInfo = 'Google Info';
            ActionModifier.SearchApiSuggestions = 'SearchApi Suggestions';
            ActionModifier.SearchApiSuggestionsError = 'SearchApi Suggestions Error';
            ActionModifier.Suggestions = 'Suggestions';
            ActionModifier.MailToCTA = 'CTA MailTo';
            ActionModifier.ContentDrawer = 'Content Drawer';
            ActionModifier.ReportCTA = 'Report CTA';
            ActionModifier.ReportModal = 'Report Modal';
            ActionModifier.D365License = 'Dynamic license dispute';
            ActionModifier.EmbedD365InstallButton = 'Dynamic Install Button';
            ActionModifier.EmbedBAGBuyLicenseButton = 'BAG Offer Buy License Button';
            ActionModifier.UserProfileEdit = 'User profile edit';
            ActionModifier.LeadCampaignGeneration = 'Lead Campaign Generate';
            ActionModifier.CTACheckBox = 'CTA Dialog Checkbox';
            ActionModifier.AppDetailCTAButton = 'App Detail Page CTA Button';
            ActionModifier.AppDetailCTAButtonFromTable = 'App Detail Page CTA Button From Table';
            ActionModifier.ECADetailCTAButton = 'ECA Detail Page CTA Button';
            ActionModifier.AppDynamicCampaignCTAButton = 'Dynamic Campaign CTA Button';
            ActionModifier.AppTileCTAButton = 'App Tile CTA Button';
            ActionModifier.ServiceDetailCTAButton = 'Service Detail Page CTA Button';
            ActionModifier.ServiceTileCTAButton = 'Service Tile CTA Button';
            ActionModifier.PartnerCTAButton = 'Partner CTA Button';
            ActionModifier.ReviewItemMoreButton = 'Review Item More Button';
            ActionModifier.ReviewPageNavigationButton = 'Review Page Navigation Button';
            ActionModifier.ReviewsGetMarkedAsHelpful = 'Reviews Get Marked As Helpful';
            ActionModifier.ReviewSetMarkedAsHelpful = 'Review Set Marked As Helpful';
            ActionModifier.ReviewItemMarkAsHelpfulUnauthorizedMessage = 'Review Item Mark As Helpful Unauthorized Message';
            ActionModifier.ReviewItemMarkAsHelpfulButton = 'Review Item Mark As Helpful Button';
            ActionModifier.ReviewItemMarkAsHelpfulSignIn = 'Review Item Mark As Helpful SignIn';
            ActionModifier.ReviewItemMarkAsHelpfulDialog = 'Review Item Mark As Helpful Dialog';
            ActionModifier.ReviewItemCommentsToggleButton = 'Review Item Comments Toggle Button';
            ActionModifier.ReviewItemCommentsSeeMore = 'Review Item Comments See More';
            ActionModifier.ReviewItemCommentsSignIn = 'Review Item Comments Sign In';
            ActionModifier.ReviewItemCommentsSeeLess = 'Review Item Comments See Less';
            ActionModifier.ReviewItemCommentDialog = 'Review Item Comment Dialog';
            ActionModifier.ReviewItemCommentDialogUpdate = 'Review Item Comment Dialog Update';
            ActionModifier.ReviewItemCommentDialogDelete = 'Review Item Comment Dialog Delete';
            ActionModifier.ReviewItemCommentCreationSubmit = 'Review Item Comment Creation Submit';
            ActionModifier.ReviewItemCommentEditButton = 'Review Item Comment Edit Button';
            ActionModifier.ReviewItemCommentDeleteButton = 'Review Item Comment Delete Button';
            ActionModifier.ReviewItemCommentedReviewIds = 'Review Item Commented Review Ids';
            ActionModifier.ReportReview = 'Report review';
            ActionModifier.LocalStorageItem = 'Local Storage Item';
            ActionModifier.SessionStorageItem = 'Session Storage Item';
            ActionModifier.CookieItem = 'Cookie Item';
            ActionModifier.BrowserStorageCookieDataBuffer = 'Browser Storage Cookie Data Buffer';
            ActionModifier.BrowserStorageLocalStorageDataBuffer = 'Browser Storage Local Storage Data Buffer';
            ActionModifier.AssignLicensesButton = 'Assign Licenses Button';
            ActionModifier.UserFavouriteNavigationBarButton = 'User Favourite Navigation Bar Button';
            ActionModifier.UserFavouriteTileDetailButton = 'User Favourite Tile Detail Button';
            ActionModifier.UserFavouriteTileButton = 'User Favourite Tile Button';
            ActionModifier.UserFavouriteDetailPage = 'User Favourite Detail Page';
            ActionModifier.OpenRatingModalFromReviewTab = 'Open Rating Modal From Review Tab';
            ActionModifier.HeaderTextItem = 'Header Text Item';
            ActionModifier.Purchase = 'Purchase';
            ActionModifier.CompletePurchase = 'CompletePurchase';
            ActionModifier.ToggleAdminExperience = 'ToggleAdminExperience';
            ActionModifier.PidlNoSelectionOptionsFound = 'No Selection PI Option Found';
            ActionModifier.PidlAddNewPaymentMethod = 'Add New Payment Method Button';
            ActionModifier.PidlAddPILoad = 'PIDL Load - Add Payment Method';
            ActionModifier.PidlHandlePaymentChallenge = 'PIDL Handle Payment Challenge';
            ActionModifier.ConfigureNowButton = 'Configure Now Button';
            ActionModifier.ConfigureNowLink = 'Configure Now Link';
            ActionModifier.PlanSelected = 'PlanSelected';
            ActionModifier.TermSelected = 'TermSelected';
            ActionModifier.PlaceOrderClicked = 'PlaceOrderClicked';
            ActionModifier.HandleTransactCheckout = 'Handle Transact Checkout Modal Redirect';
            ActionModifier.ScrollToTopButton = 'ScrollToTopButton';
            ActionModifier.FilterPDPReviews = 'Filter PDP Reviews';
            ActionModifier.SortPDPReviews = 'Sort PDP Reviews';
            ActionModifier.SortSearchResults = 'Sort Search Results';
            ActionModifier.SortSearchOpened = 'Sort Search Opened';
            ActionModifier.SearchWithinCurrentFilter = 'Search within current filter';
            ActionModifier.HomeApps = 'Home Apps Info';
            ActionModifier.PrivateOffers = 'private offers nav bar';
            ActionModifier.WriteReview = 'Write a review';
            ActionModifier.UpdateReview = 'Update a review';
            ActionModifier.DeleteReview = 'Delete a review';
            ActionModifier.OfficeOffersPurchase = 'Office Offers Purchase';
            ActionModifier.SitemapLinkClick = 'Sitemap Link Click';
            ActionModifier.ExternalRatingSummaryLink = 'External Rating Summary Link';
            ActionModifier.ExternalReviewLink = 'External Review Link';
            ActionModifier.ExternalLink = 'External Link';
            ActionModifier.InternalLink = 'Internal Link';
            ActionModifier.PurchaseErrorLink = 'Purchase Error Link';
            ActionModifier.CreateCustomer = 'Create customer';
            ActionModifier.NextCheckoutStep = 'Next Checkout Page';
            ActionModifier.ViewAllButton = 'View all button';
            ActionModifier.ClearFilters = 'Clear filters';
            ActionModifier.ClearSearchBoxText = 'Clear search box text';
            ActionModifier.ClearSearch = 'Clear search';
            ActionModifier.NoSearchResultsPage = 'No search results page';
            ActionModifier.NpsPreviewDismissed = 'Preview dismissed';
            ActionModifier.NpsSurveyDismissed = 'Survey dismissed';
            ActionModifier.NpsSurveySubmitted = 'Survey submitted';
            ActionModifier.NpsPresented = 'Presented';
            ActionModifier.SmileFrownFeedbackOpened = 'Opened';
            ActionModifier.SmileFrownFeedbackDismissed = 'Dismissed';
            ActionModifier.SearchApiNoResults = 'search api no results';
            ActionModifier.MarkoApiNoResults = 'marko api no results';
            ActionModifier.LongTermSaasTablePresented = 'Long Term SaaS Table Presented';
            ActionModifier.Complete = 'complete';
            ActionModifier.BillingCountrySelected = 'BillingCountrySelected';
            ActionModifier.BannerHyperLink = 'BannerHL';
            ActionModifier.BannerClick = 'BannerCL';
            ActionModifier.SSO_DETACHED_IFRAME_FROM_DOM = 'SSO iframe detached from DOM';
            ActionModifier.SSO_LOGIN_SUCCEEDED = 'SSO Login succeeded';
            ActionModifier.WINDOW_LISTENERS_INITIATED = 'Window listeners initiated';
            ActionModifier.SSR_LOGIN_STARTED = 'SSR login in process';
            ActionModifier.SSO_LOGIN_STARTED = 'SSO login started';
            ActionModifier.SSO_IFRAME_LOADED = 'SSO iframe loaded';
            ActionModifier.SSO_IFRAME_ATTACHED_TO_DOM = 'SSO iframe attached to DOM';
            ActionModifier.SSO_GET_LOGIN_URL = 'got user login url';
            ActionModifier.SSO_EXTRACT_CODE_NO_IFRAME = 'missing iframe element to extract code';
            ActionModifier.SSO_EMPTY_IFRAME_CODE = 'missing code in iframe';
            ActionModifier.SSO_LOGIN_ERROR = 'SSO login error';
            ActionModifier.SSO_LOGIN_TIMEOUT = 'SSO login timeout';
            ActionModifier.SSO_IFRAME_CODE_FOUND = 'found iframe code to extract refresh token';
            ActionModifier.SSO_FIRST_ATTEMPT = 'silent login attempt';
            ActionModifier.SSO_FALLBACK_ATTEMPT = 'explicit login attempt';
            ActionModifier.AccessTokenSilentFetchingError = 'AccessTokenSilentFetchingError';
            ActionModifier.AccessTokenSilentFetchingSuccess = 'AccessTokenSilentFetchingSuccess';
            ActionModifier.CreateAuthenticatedUserFailure = 'CreateAuthenticatedUserFailure';
            ActionModifier.CreateAuthenticatedUserSuccess = 'CreateAuthenticatedUserSuccess';
            ActionModifier.MsalInitializationSuccess = 'MsalInitializationSuccess';
            ActionModifier.MsalInitializationError = 'MsalInitializationError';
            ActionModifier.PreAuthRedirectFailed = 'PreAuthRedirectFailed';
            ActionModifier.AuthRedirectFailed = 'AuthRedirectFailed';
            ActionModifier.AuthRedirectSucceed = 'AuthRedirectSucceed';
            ActionModifier.AuthRedirectNotFromAAD = 'AuthRedirectNotFromAAD';
            ActionModifier.LogoutFailed = 'LogoutFailed';
            ActionModifier.AzureRedirect = 'AzureRedirect';
            ActionModifier.GetLinkedInProductGroup = 'get LinkedIn product group';
            ActionModifier.MenuClick = 'Menu Click';
            ActionModifier.Linkedin = 'Linkedin';
            ActionModifier.LinkedinFeedbackButton = 'Linkedin feedback button';
            ActionModifier.LinkedinLink = 'Linkedin link';
            ActionModifier.LinkedinEventLink = 'Linkedin event link';
            ActionModifier.LinkedinFeedbackSubmit = 'Linkedin feedback submit';
            ActionModifier.LinkedinFeedbackDismiss = 'Linkedin feedback dismiss';
            ActionModifier.OfflineRemote = 'Offline Remote';
            ActionModifier.OnlineRemote = 'Online Remote';
            ActionModifier.RemoveEventListener = 'Remove event listener';
            ActionModifier.HandleNewConsent = 'Handle new consent';
            ActionModifier.GetConsent = 'Get consent';
            ActionModifier.WcpConsentCallBack = 'WCP consent callback';
            ActionModifier.GetItem = 'GetItem';
            ActionModifier.SaveItem = 'SaveItem';
            ActionModifier.MigrationStateOldOnly = 'OldOnly';
            ActionModifier.MigrationStateNewOnly = 'NewOnly';
            ActionModifier.MigrationStateSideBySide = 'SideBySide';
        })(Telemetry.ActionModifier || (Telemetry.ActionModifier = {}));
        (function(LeadsDropReason) {
            LeadsDropReason.PreviewOffer = 'Preview offer.';
            LeadsDropReason.AppNotAvailableOrPrivate = 'App is not available or private.';
            LeadsDropReason.PowerBiTransact = 'Power BI Visuals leads allowed only for transact apps, with Buy Now CTA.';
            LeadsDropReason.ConsultingServices = 'Consulting services app is not part of the leads migration for now.';
            LeadsDropReason.EmbedWithoutLead = 'Embedded with offer type that defined not to generate lead.';
            LeadsDropReason.UserNotSignedIn = 'User not signed in.';
            LeadsDropReason.ItemNotAvailable = 'Item not available';
        })(Telemetry.LeadsDropReason || (Telemetry.LeadsDropReason = {}));
        (function(OutRequest) {
            OutRequest.Start = 'HttpOutboundRequest';
            OutRequest.EndWithSuccess = 'HttpOutboundRequestEndWithSuccess';
            OutRequest.EndWithClientError = 'HttpOutboundRequestEndWithClientError';
            OutRequest.EndWithServerError = 'HttpOutboundRequestEndWithServerError';
        })(Telemetry.OutRequest || (Telemetry.OutRequest = {}));
        (function(ProbeName) {
            ProbeName.LogInfo = 'logTelemetryInfo';
            ProbeName.FlushInfo = 'flushTelemetryInfo';
            ProbeName.LogAndFlushInfo = 'logAndFlushTelemetryInfo';
        })(Telemetry.ProbeName || (Telemetry.ProbeName = {}));
        (function(AreaName) {
            AreaName.FilterPane = 'Filter Pane';
            AreaName.AppDetails = 'App Details';
            AreaName.SuggestedSearch = 'Suggested Search';
            AreaName.SearchEntityDropDown = 'Search Entity Drop Down';
            AreaName.AppTile = 'App Tile';
            AreaName.ParentSaaSTile = 'Parent SaaS Tile';
            AreaName.BundleAddIn = 'Bundle Add-In';
            AreaName.ConsentModal = 'Consent Modal Dialog';
        })(Telemetry.AreaName || (Telemetry.AreaName = {}));
        (function(FeedbackName) {
            FeedbackName.Nps = 'NPS';
        })(Telemetry.FeedbackName || (Telemetry.FeedbackName = {}));
        (function(TemplateName) {
            TemplateName.SaaSBundle = 'SaaS Bundle';
        })(Telemetry.TemplateName || (Telemetry.TemplateName = {}));
        (function(Id) {
            Id.SuggestedClick = 'Suggested Click';
            Id.SearchDropDownClick = 'Search Drop Down Click';
            Id.Nps = 'NPS';
        })(Telemetry.Id || (Telemetry.Id = {}));
        (function(ContentType) {
            ContentType.LinkExpanded = 'Gallery filter link expanded';
            ContentType.LinkClicked = 'Gallery filter link clicked';
            ContentType.SaaSBundlePageView = 'SaaS Bundle Page View';
            ContentType.AddInBundlePageView = 'AddIn Bundle Page View';
            ContentType.CheckoutBundlePageView = 'SaaSBundle Checkout PageView';
            ContentType.OrderConfirmationBundlePageView = 'SaaSBundle OrderConfirmation PageView';
            ContentType.PlaceOrderSaaSBundle = 'SaaSBundle Place Order';
            ContentType.SkipConsentModal = 'SKIP_CONSENT';
        })(Telemetry.ContentType || (Telemetry.ContentType = {}));
        (function(PurchaseBlendsTelemetry) {
            PurchaseBlendsTelemetry.Bootstrapped = 'Bootstrapped';
            (function(Errors) {
                Errors.PBErrorPrefix = '[PB] Failure with status: ';
                Errors.ErrorIdPrefix = 'Error ids: ';
            })(PurchaseBlendsTelemetry.Errors || (PurchaseBlendsTelemetry.Errors = {}));
            PurchaseBlendsTelemetry.DismissedPrefix = 'Dismissed: ';
            PurchaseBlendsTelemetry.TotalTimeForPlaceOrderPrefix = 'Total time for purchase since place order: ';
            PurchaseBlendsTelemetry.PlaceOrderSuccess = '[PB] Place order success: ';
            PurchaseBlendsTelemetry.FinishedLoading = '[PB] FinishedLoading';
            PurchaseBlendsTelemetry.PageName = 'PurchaseBlends';
            PurchaseBlendsTelemetry.EditProfile = 'EditProfile';
            PurchaseBlendsTelemetry.EditProfileName = '[PB] Edit profile';
            PurchaseBlendsTelemetry.AddProfile = 'AddProfile';
            PurchaseBlendsTelemetry.AddProfileName = '[PB] Add profile';
            PurchaseBlendsTelemetry.PickBillingFrequency = 'PickBillingFrequency';
            PurchaseBlendsTelemetry.BillingFrequencyComponent = 'BillingFrequencyComponent';
            PurchaseBlendsTelemetry.PickBillingTerm = 'PickBillingTerm';
            PurchaseBlendsTelemetry.BillingTermComponent = 'BillingTermComponent';
            PurchaseBlendsTelemetry.AddPayment = 'AddPayment';
            PurchaseBlendsTelemetry.AddPaymentName = '[PB] Add payment';
            PurchaseBlendsTelemetry.AddBillingProfile = 'AddBillingProfile';
            PurchaseBlendsTelemetry.AddBillingProfileName = '[PB] Add billing profile';
            PurchaseBlendsTelemetry.EditBillingProfile = 'EditBillingProfile';
            PurchaseBlendsTelemetry.EditBillingProfileName = '[PB] Edit billing profile';
            PurchaseBlendsTelemetry.PurchaseBlendsDisclaimerComponent = 'PurchaseBlendsDisclaimerComponent';
            PurchaseBlendsTelemetry.PurchaseBlendsDisclaimerComponentName = 'Show user consent for disclaimer';
        })(Telemetry.PurchaseBlendsTelemetry || (Telemetry.PurchaseBlendsTelemetry = {}));
    })(Constants.Telemetry || (Constants.Telemetry = {}));
    (function(PurchaseBlends) {
        PurchaseBlends.NewCheckout = 'NewCheckout';
        PurchaseBlends.OldCheckout = 'OldCheckout';
        PurchaseBlends.AlreadyPurchasedKey = 'AlreadyPurchasedWithNewExperience';
        PurchaseBlends.AdminFlow = 'AdminFlow';
        PurchaseBlends.IWFlow = 'IWFlow';
        PurchaseBlends.Enrolled = 'true';
        PurchaseBlends.Excluded = 'false';
        PurchaseBlends.AlreadyPurchased = 'v';
    })(Constants.PurchaseBlends || (Constants.PurchaseBlends = {}));
    (function(RoleDefinitions) {
        RoleDefinitions.globalAdmin = '62e90394-69f5-4237-9190-012177145e10';
        RoleDefinitions.billingAdmin = 'b0f54661-2d74-4c50-afa3-1ec803f12efe';
        RoleDefinitions.rolesToCheck = [
            RoleDefinitions.globalAdmin,
            RoleDefinitions.billingAdmin
        ];
    })(Constants.RoleDefinitions || (Constants.RoleDefinitions = {}));
    (function(Flighting) {
        Flighting.OldCheckout = 'OldCheckout';
        Flighting.NewCheckout = 'NewCheckout';
    })(Constants.Flighting || (Constants.Flighting = {}));
    Constants.scrubbedHeaderValue = 'SCRUBBED';
    Constants.apiServicePrefix = 'api/v2.0';
    Constants.marketplaceApiServicePrefix = 'api';
    Constants.armSubscriptionApiVersion = '2020-01-01';
    Constants.armBillingAccountsApiVersion = '2019-10-01-preview';
    Constants.armIsMaccApiVersion = '2018-08-01-beta';
    Constants.mprpApiVersion = '2018-08-01-beta';
    Constants.appsourceApiVersion = '2017-04-24';
    Constants.dbSchemaVersion = '2017-04-24';
    Constants.userCollectionSchemaVersion = '2016-10-14';
    Constants.acquisitionCollectionSchemaVersion = '2017-04-27';
    Constants.TestDrivePath = 'JwtTokenDemoSession';
    Constants.MetadataDocType = 'Metadata';
    Constants.partitionedCollectionVersion = '2017-04-24';
    Constants.apiVersion = 'apiVersion';
    Constants.reviewsAPI = 'reviewsAPI';
    Constants.reviewsAPIVersion = 'reviewsAPIVersion';
    Constants.bundleVersion = 'bundleVersion';
    Constants.regionName = 'regionName';
    Constants.marketplaceApiVersion = 'marketplaceApiVersion';
    Constants.azureMarketplace = 'AzureMarketplace';
    Constants.appSource = 'AppSource';
    Constants.appSourceEmbed = 'AppSource_Embed';
    (function(CompetencyBadge) {
        CompetencyBadge[CompetencyBadge["Gold"] = 0] = "Gold";
        CompetencyBadge[CompetencyBadge["Silver"] = 1] = "Silver";
        CompetencyBadge[CompetencyBadge["BadgeNotFound"] = 2] = "BadgeNotFound";
    })(Constants.CompetencyBadge || (Constants.CompetencyBadge = {}));
    Constants.FeaturedAppsOrder = [
        '99',
        '64',
        '128',
        '1024',
        '256',
        '1',
        '8',
        '512',
        '4',
        '32',
        '16'
    ];
    Constants.validEmbedExperienceProducts = [
        'power-bi',
        'power-bi-visuals',
        'dynamics-365-business-central',
        'dynamics-365-for-sales',
        'dynamics-365'
    ];
    Constants.validEmbedExperienceEmbedHost = [
        'admin-portal',
        'dynamics-365'
    ];
    (function(TestDriveType) {
        TestDriveType.Showcase = 'Showcase';
        TestDriveType.AzureTestDriveService = 'AzureTestDriveService';
        TestDriveType.SolutionsTestDrive = 'SolutionsTestDrive';
    })(Constants.TestDriveType || (Constants.TestDriveType = {}));
    (function(TestDriveOutputType) {
        TestDriveOutputType.HandOffUrl = 'handoffurl';
        TestDriveOutputType.MetadataMarkdown = 'metadatamarkdown';
    })(Constants.TestDriveOutputType || (Constants.TestDriveOutputType = {}));
    (function(EmailCategories) {
        EmailCategories.ContactSI = 'Contact SI';
        EmailCategories.ContactSICrossListing = 'Contact SI (Cross listing)';
        EmailCategories.CorrelationIdArgKey = 'correlationId';
        EmailCategories.UserIdArgKey = 'userId';
    })(Constants.EmailCategories || (Constants.EmailCategories = {}));
    (function(ReservedCorrelationIds) {
        ReservedCorrelationIds.EmptyId = '00000000-0000-0000-0000-000000000000';
        ReservedCorrelationIds.RepoCacheRefresh = '00000000-0000-0000-0000-000000000001';
        ReservedCorrelationIds.SignInEmptyId = '00000000-0000-0000-0000-000000000002';
        ReservedCorrelationIds.ErrorId = '00000000-0000-0000-0000-111111111111';
    })(Constants.ReservedCorrelationIds || (Constants.ReservedCorrelationIds = {}));
    (function(ReservedOperationNames) {
        ReservedOperationNames.RepoCacheRefresh = 'RepoCacheRefresh';
    })(Constants.ReservedOperationNames || (Constants.ReservedOperationNames = {}));
    (function(CloudsIndustry) {
        CloudsIndustry.bitmaskPrefix = 'clouds_';
    })(Constants.CloudsIndustry || (Constants.CloudsIndustry = {}));
    (function(Endpoints) {
        (function(View) {
            View.AppPricing = '/view/appPricing';
            View.TileData = '/view/tiledata';
            View.FilteredApps = '/view/filteredapps';
            View.AppFuturePricing = '/view/appFuturePricing';
            View.CloudsIndustryDataMap = '/view/cloudsindustrydatamap';
            View.CloudsIndustryFeatured = '/view/featuredcloudsindustry';
            View.CloudsIndustryFiltered = '/view/filteredcloudsindustry';
        })(Endpoints.View || (Endpoints.View = {}));
    })(Constants.Endpoints || (Constants.Endpoints = {}));
    (function(TestDriveResponse) {
        TestDriveResponse.DemoSessionId = 'demoSessionId';
        TestDriveResponse.Status = 'status';
        TestDriveResponse.OutputItemList = 'outputItemList';
        TestDriveResponse.HandOffUrl = 'HandOffUrl';
        TestDriveResponse.StringKey = 'String';
        TestDriveResponse.AppUri = 'app Uri';
        TestDriveResponse.TestDrive = 'TestDrive';
        TestDriveResponse.SessionSource = 'sessionSource';
        TestDriveResponse.StoppedTime = 'stoppedTime';
        TestDriveResponse.MarketPlaceMetadataMarkdownKey = '_marketPlaceMetadataMarkdown';
    })(Constants.TestDriveResponse || (Constants.TestDriveResponse = {}));
    (function(VersionNeutralCollection) {
        VersionNeutralCollection.Reviews = 'reviews';
        VersionNeutralCollection.Users = 'users';
    })(Constants.VersionNeutralCollection || (Constants.VersionNeutralCollection = {}));
    (function(DocTypes) {
        DocTypes.App = 'App';
        DocTypes.Pricing = 'Pricing';
        DocTypes.SolutionManifest = 'SolutionManifest';
    })(Constants.DocTypes || (Constants.DocTypes = {}));
    (function(TestDriveState) {
        TestDriveState[TestDriveState["Hot"] = 0] = "Hot";
        TestDriveState[TestDriveState["Cold"] = 1] = "Cold";
        TestDriveState[TestDriveState["Error"] = 2] = "Error";
        TestDriveState[TestDriveState["Unknown"] = 3] = "Unknown";
    })(Constants.TestDriveState || (Constants.TestDriveState = {}));
    (function(StorefrontName) {
        StorefrontName.AppSource = 'AppSource';
        StorefrontName.Amp = 'Amp';
        StorefrontName.Ibiza = 'Ibiza';
        StorefrontName.G2 = 'G2';
        StorefrontName.Embed = 'Embed';
    })(Constants.StorefrontName || (Constants.StorefrontName = {}));
    Constants.InternalStoreFronts = [
        Constants.StorefrontName.AppSource,
        Constants.StorefrontName.Amp,
        Constants.StorefrontName.Ibiza
    ];
    (function(AuthType) {
        AuthType[AuthType["MSA"] = 1] = "MSA";
        AuthType[AuthType["AAD"] = 2] = "AAD";
    })(Constants.AuthType || (Constants.AuthType = {}));
    (function(ResourceTypes) {
        ResourceTypes[ResourceTypes["AppRelatedItems"] = 0] = "AppRelatedItems";
        ResourceTypes[ResourceTypes["ServiceRelatedItems"] = 1] = "ServiceRelatedItems";
        ResourceTypes[ResourceTypes["DataMapCloudsIndustry"] = 2] = "DataMapCloudsIndustry";
        ResourceTypes[ResourceTypes["DataMapApps"] = 3] = "DataMapApps";
        ResourceTypes[ResourceTypes["DataMapServices"] = 4] = "DataMapServices";
        ResourceTypes[ResourceTypes["FilteredApps"] = 5] = "FilteredApps";
        ResourceTypes[ResourceTypes["FilteredServices"] = 6] = "FilteredServices";
        ResourceTypes[ResourceTypes["FilteredCloudsIndustry"] = 7] = "FilteredCloudsIndustry";
        ResourceTypes[ResourceTypes["CuratedServices"] = 8] = "CuratedServices";
        ResourceTypes[ResourceTypes["CuratedApps"] = 9] = "CuratedApps";
        ResourceTypes[ResourceTypes["CuratedCloudsIndustry"] = 10] = "CuratedCloudsIndustry";
        ResourceTypes[ResourceTypes["FlightCodedApp"] = 11] = "FlightCodedApp";
        ResourceTypes[ResourceTypes["PreviewServices"] = 12] = "PreviewServices";
        ResourceTypes[ResourceTypes["PreviewPricing"] = 13] = "PreviewPricing";
        ResourceTypes[ResourceTypes["PreviewApps"] = 14] = "PreviewApps";
        ResourceTypes[ResourceTypes["PreviewCloudsIndustry"] = 15] = "PreviewCloudsIndustry";
        ResourceTypes[ResourceTypes["HashMapApps"] = 16] = "HashMapApps";
        ResourceTypes[ResourceTypes["HashMapServices"] = 17] = "HashMapServices";
        ResourceTypes[ResourceTypes["HashMapPreviewApps"] = 18] = "HashMapPreviewApps";
        ResourceTypes[ResourceTypes["HashMapPreviewServices"] = 19] = "HashMapPreviewServices";
        ResourceTypes[ResourceTypes["App"] = 20] = "App";
        ResourceTypes[ResourceTypes["Service"] = 21] = "Service";
        ResourceTypes[ResourceTypes["AllPublicCloudsIndustry"] = 22] = "AllPublicCloudsIndustry";
        ResourceTypes[ResourceTypes["AllCloudsIndustry"] = 23] = "AllCloudsIndustry";
        ResourceTypes[ResourceTypes["AllApps"] = 24] = "AllApps";
        ResourceTypes[ResourceTypes["RawAllApps"] = 25] = "RawAllApps";
        ResourceTypes[ResourceTypes["RawAllAppsCatalog"] = 26] = "RawAllAppsCatalog";
        ResourceTypes[ResourceTypes["AllAppsExtra"] = 27] = "AllAppsExtra";
        ResourceTypes[ResourceTypes["FeaturedApps"] = 28] = "FeaturedApps";
        ResourceTypes[ResourceTypes["FeaturedCloudsIndustry"] = 29] = "FeaturedCloudsIndustry";
        ResourceTypes[ResourceTypes["FlightCodedAndLiveApps"] = 30] = "FlightCodedAndLiveApps";
        ResourceTypes[ResourceTypes["User"] = 31] = "User";
        ResourceTypes[ResourceTypes["Pricing"] = 32] = "Pricing";
        ResourceTypes[ResourceTypes["AppPricing"] = 33] = "AppPricing";
        ResourceTypes[ResourceTypes["SolutionMetadata"] = 34] = "SolutionMetadata";
        ResourceTypes[ResourceTypes["SolutionRuntime"] = 35] = "SolutionRuntime";
        ResourceTypes[ResourceTypes["Acquisition"] = 36] = "Acquisition";
        ResourceTypes[ResourceTypes["AllServices"] = 37] = "AllServices";
        ResourceTypes[ResourceTypes["CatalogStartingPrices"] = 38] = "CatalogStartingPrices";
        ResourceTypes[ResourceTypes["RawAllServices"] = 39] = "RawAllServices";
        ResourceTypes[ResourceTypes["AllServicesExtra"] = 40] = "AllServicesExtra";
        ResourceTypes[ResourceTypes["FeaturedServives"] = 41] = "FeaturedServives";
        ResourceTypes[ResourceTypes["UserProfile"] = 42] = "UserProfile";
        ResourceTypes[ResourceTypes["Event"] = 43] = "Event";
        ResourceTypes[ResourceTypes["Review"] = 44] = "Review";
        ResourceTypes[ResourceTypes["AllConsultingServices"] = 45] = "AllConsultingServices";
        ResourceTypes[ResourceTypes["FeaturedServicesSections"] = 46] = "FeaturedServicesSections";
        ResourceTypes[ResourceTypes["ServiceAcquisitions"] = 47] = "ServiceAcquisitions";
        ResourceTypes[ResourceTypes["Favourites"] = 48] = "Favourites";
        ResourceTypes[ResourceTypes["AllECAOffers"] = 49] = "AllECAOffers";
        ResourceTypes[ResourceTypes["AllAppReviews"] = 50] = "AllAppReviews";
        ResourceTypes[ResourceTypes["ECAAcquisitions"] = 51] = "ECAAcquisitions";
        ResourceTypes[ResourceTypes["ReviewsByAppId"] = 52] = "ReviewsByAppId";
        ResourceTypes[ResourceTypes["ReviewByIdByUser"] = 53] = "ReviewByIdByUser";
        ResourceTypes[ResourceTypes["Customer"] = 54] = "Customer";
        ResourceTypes[ResourceTypes["CustomerAddress"] = 55] = "CustomerAddress";
        ResourceTypes[ResourceTypes["CalculatePrice"] = 56] = "CalculatePrice";
        ResourceTypes[ResourceTypes["Purchase"] = 57] = "Purchase";
        ResourceTypes[ResourceTypes["PublisherOffer"] = 58] = "PublisherOffer";
        ResourceTypes[ResourceTypes["AllServicesCountries"] = 59] = "AllServicesCountries";
        ResourceTypes[ResourceTypes["PrivateApps"] = 60] = "PrivateApps";
        ResourceTypes[ResourceTypes["BillingAccounts"] = 61] = "BillingAccounts";
    })(Constants.ResourceTypes || (Constants.ResourceTypes = {}));
    Constants.Office365Mapping = {
        // Legacy Online
        SharePoint_Online: [
            'SharePoint Online'
        ],
        Access_Online: [
            'Access Online'
        ],
        OneNote_Online: [
            'OneNote Online'
        ],
        Project_Online: [
            'Project Online'
        ],
        // On The Web
        Outlook_Online: [
            'ProductOnTheWeb',
            'Outlook'
        ],
        Excel_Online: [
            'ProductOnTheWeb',
            'Excel'
        ],
        PowerPoint_Online: [
            'ProductOnTheWeb',
            'PowerPoint'
        ],
        Word_Online: [
            'ProductOnTheWeb',
            'Word'
        ],
        Office_Online: [
            'ProductOnTheWeb',
            'Office app'
        ],
        // iPad
        Excel_iPad: [
            'ProductOnIpad',
            'Excel'
        ],
        Word_iPad: [
            'ProductOnIpad',
            'Word'
        ],
        PowerPoint_iPad: [
            'ProductOnIpad',
            'PowerPoint'
        ],
        // iOS
        Office_iOS: [
            'ProductOnIos',
            'Office app'
        ],
        Outlook_iOS: [
            'ProductOnIos',
            'Outlook'
        ],
        // Android
        Office_Android: [
            'ProductOnAndroid',
            'Office app'
        ],
        Outlook_Android: [
            'ProductOnAndroid',
            'Outlook'
        ],
        // Other
        App_Details_Requirements_Products_Office365: [
            'Office 365'
        ],
        App_Details_Requirements_Products_ExcelIOS: [
            'Excel for iPad'
        ],
        App_Details_Requirements_Products_WordIOS: [
            'Word for iPad'
        ],
        App_Details_Requirements_Products_OutlookOnWeb: [
            'ProductOnTheWeb',
            'Outlook'
        ],
        App_Details_Requirements_Products_PowerPointIOS: [
            'PowerPoint for iPad'
        ],
        App_Details_Requirements_Products_OneNoteWindows10: [
            'OneNote for Windows 10'
        ],
        App_Details_Requirements_Products_PowerBI: [
            'Power BI'
        ],
        App_Details_Requirements_Products_Teams: [
            'Teams'
        ],
        OfficeProductForAndroid: [
            'Outlook for Android'
        ],
        OfficeProductForIOS: [
            'Outlook for iOS'
        ],
        Office: [
            'Office app on Windows'
        ],
        // MAC products
        Word_2016_Mac: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Word 2016',
                'Mac'
            ]
        ],
        Word_2019_Mac: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Word 2019',
                'Mac'
            ]
        ],
        Excel_2016_Mac: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Excel 2016',
                'Mac'
            ]
        ],
        Excel_2019_Mac: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Excel 2019',
                'Mac'
            ]
        ],
        PowerPoint_2016_Mac: [
            'ProductVersionOrLaterOnPlatform',
            [
                'PowerPoint 2016',
                'Mac'
            ]
        ],
        PowerPoint_2019_Mac: [
            'ProductVersionOrLaterOnPlatform',
            [
                'PowerPoint 2019',
                'Mac'
            ]
        ],
        Outlook_2016_Mac: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Outlook 2016',
                'Mac'
            ]
        ],
        Outlook_2019_Mac: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Outlook 2019',
                'Mac'
            ]
        ],
        // WIN products
        Word_2013: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Word 2013',
                'Windows'
            ]
        ],
        Word_2013_SP1: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Word 2013 SP1',
                'Windows'
            ]
        ],
        Word_2016: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Word 2016',
                'Windows'
            ]
        ],
        Word_2019: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Word 2019',
                'Windows'
            ]
        ],
        Excel_2013: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Excel 2013',
                'Windows'
            ]
        ],
        Excel_2013_SP1: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Excel 2013 SP1',
                'Windows'
            ]
        ],
        Excel_2016: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Excel 2016',
                'Windows'
            ]
        ],
        Excel_2019: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Excel 2019',
                'Windows'
            ]
        ],
        PowerPoint_2013: [
            'ProductVersionOrLaterOnPlatform',
            [
                'PowerPoint 2013',
                'Windows'
            ]
        ],
        PowerPoint_2013_SP1: [
            'ProductVersionOrLaterOnPlatform',
            [
                'PowerPoint 2013 SP1',
                'Windows'
            ]
        ],
        PowerPoint_2016: [
            'ProductVersionOrLaterOnPlatform',
            [
                'PowerPoint 2016',
                'Windows'
            ]
        ],
        PowerPoint_2019: [
            'ProductVersionOrLaterOnPlatform',
            [
                'PowerPoint 2019',
                'Windows'
            ]
        ],
        Outlook_2013: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Outlook 2013',
                'Windows'
            ]
        ],
        Outlook_2013_SP1: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Outlook 2013 SP1',
                'Windows'
            ]
        ],
        Outlook_2016: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Outlook 2016',
                'Windows'
            ]
        ],
        Outlook_2019: [
            'ProductVersionOrLaterOnPlatform',
            [
                'Outlook 2019',
                'Windows'
            ]
        ],
        // M365 products
        Excel_M365_Win: [
            'ProductOnM365Plaform',
            [
                'Excel',
                'Windows'
            ]
        ],
        Excel_M365_Mac: [
            'ProductOnM365Plaform',
            [
                'Excel',
                'Mac'
            ]
        ],
        Word_M365_Win: [
            'ProductOnM365Plaform',
            [
                'Word',
                'Windows'
            ]
        ],
        Word_M365_Mac: [
            'ProductOnM365Plaform',
            [
                'Word',
                'Mac'
            ]
        ],
        Outlook_M365_Win: [
            'ProductOnM365Plaform',
            [
                'Outlook',
                'Windows'
            ]
        ],
        Outlook_M365_Mac: [
            'ProductOnM365Plaform',
            [
                'Outlook',
                'Mac'
            ]
        ],
        PowerPoint_M365_Win: [
            'ProductOnM365Plaform',
            [
                'PowerPoint',
                'Windows'
            ]
        ],
        PowerPoint_M365_Mac: [
            'ProductOnM365Plaform',
            [
                'PowerPoint',
                'Mac'
            ]
        ],
        // Legacy products
        OfficeProductOrLater_SharePoint_2013: [
            'ProductVersionOrLater',
            'SharePoint 2013'
        ],
        OfficeProductOrLater_SharePoint_2016: [
            'ProductVersionOrLater',
            'SharePoint 2016'
        ],
        Access_2016_SP1: [
            'ProductVersionOrLater',
            'Access 2016 SP1'
        ],
        Excel_2016_SP1: [
            'ProductVersionOrLater',
            'Excel 2016 SP1'
        ],
        OneNote_2016_SP1: [
            'ProductVersionOrLater',
            'OneNote 2016 SP1'
        ],
        Outlook_2016_SP1: [
            'ProductVersionOrLater',
            'Outlook 2016 SP1'
        ],
        Project_2016_SP1: [
            'ProductVersionOrLater',
            'Project 2016 SP1'
        ],
        PowerPoint_2016_SP1: [
            'ProductVersionOrLater',
            'PowerPoint 2016 SP1'
        ],
        Word_2016_SP1: [
            'ProductVersionOrLater',
            'Word 2016 SP1'
        ],
        Access_2013_SP1: [
            'ProductVersionOrLater',
            'Access 2013 SP1'
        ],
        OneNote_2013_SP1: [
            'ProductVersionOrLater',
            'OneNote 2013 SP1'
        ],
        Project_2013_SP1: [
            'ProductVersionOrLater',
            'Project 2013 SP1'
        ],
        Access_2016: [
            'ProductVersionOrLater',
            'Access 2016'
        ],
        OneNote_2016: [
            'ProductVersionOrLater',
            'OneNote 2016'
        ],
        Project_2016: [
            'ProductVersionOrLater',
            'Project 2016'
        ],
        Access_2013: [
            'ProductVersionOrLater',
            'Access 2013'
        ],
        OneNote_2013: [
            'ProductVersionOrLater',
            'OneNote 2013'
        ],
        Project_2013: [
            'ProductVersionOrLater',
            'Project 2013'
        ]
    };
    Constants.OfficeAwardsMapping = {
        // Office 2017 App Awards
        AppAwards_2017_BestBizValue_Place1: [
            'Best_Business_Value_for_An',
            'Merchandise_Winner',
            '2017'
        ],
        AppAwards_2017_BestBizValue_Place2: [
            'Best_Business_Value_for_An',
            'Merchandise_Second',
            '2017'
        ],
        AppAwards_2017_BestBizValue_Place3: [
            'Best_Business_Value_for_An',
            'Merchandise_Third',
            '2017'
        ],
        AppAwards_2017_BestUX_Place1: [
            'Best_User_Experience_For_An',
            'Merchandise_Winner',
            '2017'
        ],
        AppAwards_2017_BestUX_Place2: [
            'Best_User_Experience_For_An',
            'Merchandise_Second',
            '2017'
        ],
        AppAwards_2017_BestUX_Place3: [
            'Best_User_Experience_For_An',
            'Merchandise_Third',
            '2017'
        ],
        AppAwards_2017_BestInt_Place1: [
            'Best_Office_Integration_For_An',
            'Merchandise_Winner',
            '2017'
        ],
        AppAwards_2017_BestInt_Place2: [
            'Best_Office_Integration_For_An',
            'Merchandise_Second',
            '2017'
        ],
        AppAwards_2017_BestInt_Place3: [
            'Best_Office_Integration_For_An',
            'Merchandise_Third',
            '2017'
        ],
        AppAwards_2017_Mobile_Place1: [
            'Mobile_Award_For_An',
            'Merchandise_Winner',
            '2017'
        ],
        AppAwards_2017_Overall_Place1: [
            'Best_Overall_For_An',
            'Merchandise_Winner',
            '2017'
        ],
        AppAwards_2017_Overall_Place2: [
            'Best_Overall_For_An',
            'Merchandise_Second',
            '2017'
        ],
        AppAwards_2017_Overall_Place3: [
            'Best_Overall_For_An',
            'Merchandise_Third',
            '2017'
        ],
        AppAwards_2017_Peoples_Choice: [
            'Peoples_Choice_For_An',
            'Merchandise_Winner',
            '2017'
        ],
        // Office 2018 App Awards
        AppAwards_2018_BestBizValue_Place1: [
            'Best_Business_Value_for_An',
            'Merchandise_Winner',
            '2018'
        ],
        AppAwards_2018_BestBizValue_Place2: [
            'Best_Business_Value_for_An',
            'Merchandise_Second',
            '2018'
        ],
        AppAwards_2018_BestBizValue_Place3: [
            'Best_Business_Value_for_An',
            'Merchandise_Third',
            '2018'
        ],
        AppAwards_2018_BestUX_Place1: [
            'Best_User_Experience_For_An',
            'Merchandise_Winner',
            '2018'
        ],
        AppAwards_2018_BestUX_Place2: [
            'Best_User_Experience_For_An',
            'Merchandise_Second',
            '2018'
        ],
        AppAwards_2018_BestUX_Place3: [
            'Best_User_Experience_For_An',
            'Merchandise_Third',
            '2018'
        ],
        AppAwards_2018_BestInt_Place1: [
            'Best_Office_Integration_For_An',
            'Merchandise_Winner',
            '2018'
        ],
        AppAwards_2018_BestInt_Place2: [
            'Best_Office_Integration_For_An',
            'Merchandise_Second',
            '2018'
        ],
        AppAwards_2018_BestInt_Place3: [
            'Best_Office_Integration_For_An',
            'Merchandise_Third',
            '2018'
        ],
        AppAwards_2018_Overall_Place1: [
            'Best_Overall_For_An',
            'Merchandise_Winner',
            '2018'
        ],
        AppAwards_2018_Overall_Place2: [
            'Best_Overall_For_An',
            'Merchandise_Second',
            '2018'
        ],
        AppAwards_2018_Overall_Place3: [
            'Best_Overall_For_An',
            'Merchandise_Third',
            '2018'
        ],
        AppAwards_2018_Peoples_Choice: [
            'Peoples_Choice_For_An',
            'Merchandise_Winner',
            '2018'
        ],
        // Office 2019+ App Awards
        AppAwards: [
            'Office App Awards',
            'General Office App Awards',
            '2019'
        ]
    };
    Constants.AcquisitionCtaContactIgnored = 'CTA_Contact';
    Constants.DefaultLocale = 'en-us';
    Constants.DefaultLanguage = 'en';
    (function(AcquisitionCategories) {
        AcquisitionCategories.Private = 'private';
        AcquisitionCategories.Public = 'public';
    })(Constants.AcquisitionCategories || (Constants.AcquisitionCategories = {}));
    Constants.defaultRoute = '/';
    Constants.privateOffers = 'private-offers';
    Constants.home = 'home';
    Constants.csGallery = 'marketplace/consulting-services';
    Constants.appsGallery = 'marketplace/apps';
    Constants.cloudsIndustryGallery = 'marketplace/cloudsIndustry';
    Constants.appDetailsCanonicalTabSuffix = '?tab=overview';
    Constants.partnersAppSource = 'marketplace/partner-dir';
    Constants.partnersIframe = 'partners';
    Constants.partnersSearchApiRoute = 'api/search/autocomplete';
    Constants.product = 'product';
    Constants.category = 'category';
    Constants.serviceType = 'serviceType';
    Constants.industry = 'industry';
    Constants.KeepInCanonicalFilters = [
        'product',
        'category',
        'serviceType',
        'industry'
    ];
    Constants.semicolon = '%3B';
    (function(GalleryTypes) {
        GalleryTypes.consultingServices = 'consulting-services';
        GalleryTypes.apps = 'apps';
    })(Constants.GalleryTypes || (Constants.GalleryTypes = {}));
    (function(GalleryOffersTypes) {
        GalleryOffersTypes["ConsultingServices"] = "consulting services";
        GalleryOffersTypes["Apps"] = "apps";
        GalleryOffersTypes["CloudsIndustry"] = "Industry Clouds";
        GalleryOffersTypes["Partners"] = "Partners";
    })(Constants.GalleryOffersTypes || (Constants.GalleryOffersTypes = {}));
    (function(Views) {
        Views["locale"] = "locale";
        Views["appDetails"] = "appDetails";
        Views["checkout"] = "checkout";
        Views["orderConfirmation"] = "orderConfirmation";
        Views["partners"] = "partners";
        Views["blog"] = "blog";
        Views["reviews"] = "reviews";
        Views["sell"] = "sell";
        Views["about"] = "about";
        Views["billingregion"] = "billingregion";
        Views["testdrive"] = "testdrive";
        Views["fieldHub"] = "fieldHub";
        Views["serviceDetails"] = "serviceDetails";
        Views["partnerDetails"] = "partnerDetails";
        Views["partnerDetailsContact"] = "partnerDetailsContact";
        Views["partnerSuggestion"] = "partnerSuggestion";
        Views["userFavouriteDetail"] = "userFavouriteDetail";
        Views["privateOffers"] = "privateOffers";
        Views["privateOfferDetails"] = "privateOfferDetails";
        Views["campaigns"] = "campaigns";
        Views["sitemap"] = "sitemap";
        Views["home"] = "home";
        Views["serviceGallery"] = "serviceGallery";
        Views["appGallery"] = "appGallery";
        Views["cloudsIndustryGallery"] = "cloudsIndustryGallery";
        Views["partnersHost"] = "partnersHost";
    })(Constants.Views || (Constants.Views = {}));
    (function(ReportAbuseDialog) {
        ReportAbuseDialog.dropdownHTMLIdName = 'report-abuse-dialog-category-dropdown';
    })(Constants.ReportAbuseDialog || (Constants.ReportAbuseDialog = {}));
    (function(HTMLAttribute) {
        HTMLAttribute.href = 'href';
        HTMLAttribute.className = 'class';
        HTMLAttribute.alt = 'alt';
        HTMLAttribute.text = 'text';
        HTMLAttribute.ariaExpanded = 'aria-expanded';
        HTMLAttribute.textContent = 'textContent';
        HTMLAttribute.ariaSelected = 'aria-selected';
        HTMLAttribute.ariaChecked = 'aria-checked';
        HTMLAttribute.ariaLabel = 'aria-label';
        HTMLAttribute.role = 'role';
        HTMLAttribute.id = 'id';
        HTMLAttribute.ariaActivedescendant = 'aria-activedescendant';
        HTMLAttribute.ariaLabeledBy = 'aria-labelledby';
        HTMLAttribute.tabIndex = 'tabIndex';
        HTMLAttribute.title = 'title';
        HTMLAttribute.autoComplete = 'autoComplete';
    })(Constants.HTMLAttribute || (Constants.HTMLAttribute = {}));
    (function(HTMLTag) {
        HTMLTag.button = 'button';
    })(Constants.HTMLTag || (Constants.HTMLTag = {}));
    (function(HTMLClassNameStrings) {
        HTMLClassNameStrings.tile = 'spza_tileWrapper';
    })(Constants.HTMLClassNameStrings || (Constants.HTMLClassNameStrings = {}));
    (function(searchItemType) {
        searchItemType.app = 'AppSearchResult';
        searchItemType.service = 'ServicesSearchResult';
        searchItemType.cloudsIndustry = 'CloudsIndustrySearchResult';
        searchItemType.showAll = 'SearchShowAll';
        searchItemType.searchWithinFilters = 'searchWithinFilters';
        searchItemType.eca = 'ECASearchResult';
        searchItemType.partner = 'PartnerSearchResult';
    })(Constants.searchItemType || (Constants.searchItemType = {}));
    (function(searchTypeString) {
        searchTypeString.AppsAndServices = 'Apps and Services';
        searchTypeString.ECAoffers = 'ECA Offers';
        searchTypeString.Partners = 'Partners';
    })(Constants.searchTypeString || (Constants.searchTypeString = {}));
    Constants.defaultCountryForPrivacy = 'EU';
    (function(TokenClaims) {
        TokenClaims["givenName"] = "given_name";
        TokenClaims["familyName"] = "family_name";
    })(Constants.TokenClaims || (Constants.TokenClaims = {}));
    (function(AzurePortal) {
        AzurePortal.PDPBladeById = 'https://portal.azure.com/#blade/Microsoft_Azure_Marketplace/galleryItemDetailsBladeNopdl/id/{0}';
        AzurePortal.CreateOfferById = 'https://portal.azure.com/#create/';
        AzurePortal.CreateOfferPreview = '/preview';
    })(Constants.AzurePortal || (Constants.AzurePortal = {}));
    Constants.partnerCenterLink = 'https://partner.microsoft.com/en-us/dashboard/account/v3/enrollment/introduction/azureisv';
    Constants.FilterCategoryToGlobalStrings = [
        'virtual-machine-images',
        'solution-templates'
    ];
    (function(FilterQuery) {
        // azure marketplace
        FilterQuery["filters"] = "filters";
        FilterQuery["subcategories"] = "subcategories";
        FilterQuery["subindustries"] = "subindustries";
        // appsource
        FilterQuery["product"] = "product";
        FilterQuery["industry"] = "industry";
        FilterQuery["category"] = "category";
        FilterQuery["serviceType"] = "serviceType";
        FilterQuery["trials"] = "trials";
        FilterQuery["pricingModel"] = "pricingModel";
        FilterQuery["ratings"] = "ratings";
        FilterQuery["appCompliance"] = "appCompliance";
        FilterQuery["sortBy"] = "sortBy";
        FilterQuery["azureBenefitEligible"] = "azureBenefitEligible";
        FilterQuery["copilotExtension"] = "copilotExtension";
        FilterQuery["productType"] = "productType";
        FilterQuery["country"] = "country";
        FilterQuery["region"] = "region";
        FilterQuery["search"] = "search";
        FilterQuery["page"] = "page";
    })(Constants.FilterQuery || (Constants.FilterQuery = {}));
    (function(MACSubCategoryStrings) {
        MACSubCategoryStrings.FreeTrial = 'trials_freeTrial';
        MACSubCategoryStrings.Windows = 'windows';
        MACSubCategoryStrings.Linux = 'linux';
        MACSubCategoryStrings.WindowsBased = 'windowsBased';
        MACSubCategoryStrings.LinuxBased = 'linuxBased';
        MACSubCategoryStrings.SystemWindows = 'operatingSystem_windows';
        MACSubCategoryStrings.SystemLinux = 'operatingSystem_linux';
        MACSubCategoryStrings.TestDrive = 'trials_testDrive';
        MACSubCategoryStrings.Microsoft = 'Microsoft';
        MACSubCategoryStrings.PublisherMicrosoft = 'publisher_microsoft';
        MACSubCategoryStrings.PublisherPartner = 'publisher_partners';
        MACSubCategoryStrings.SaaS = 'SaaS';
        MACSubCategoryStrings.Containers = 'Containers_MP';
        MACSubCategoryStrings.ContainerImages = 'ContainerImages_MP';
        MACSubCategoryStrings.Countries = 'country';
    })(Constants.MACSubCategoryStrings || (Constants.MACSubCategoryStrings = {}));
    (function(TypeOf) {
        TypeOf.objectName = 'object';
        TypeOf.functionName = 'function';
        TypeOf.stringName = 'string';
        TypeOf.numberName = 'number';
        TypeOf.booleanName = 'boolean';
        TypeOf.undefinedName = 'undefined';
        TypeOf.nullName = 'null';
    })(Constants.TypeOf || (Constants.TypeOf = {}));
    (function(ServiceTypes) {
        ServiceTypes[ServiceTypes["Assessment"] = 1] = "Assessment";
        ServiceTypes[ServiceTypes["Briefing"] = 2] = "Briefing";
        ServiceTypes[ServiceTypes["Implementation"] = 4] = "Implementation";
        ServiceTypes[ServiceTypes["ProofOfConcept"] = 8] = "ProofOfConcept";
        ServiceTypes[ServiceTypes["WorkShop"] = 16] = "WorkShop";
    })(Constants.ServiceTypes || (Constants.ServiceTypes = {}));
    (function(RegExpFlag) {
        RegExpFlag.Global = 'g';
        RegExpFlag.MultiLine = 'm';
        RegExpFlag.CaseInsensitive = 'i';
        RegExpFlag.Sticky = 'y';
        RegExpFlag.Unicode = 'g';
        RegExpFlag.SingleLine = 'i';
    })(Constants.RegExpFlag || (Constants.RegExpFlag = {}));
    (function(UserFavourite) {
        (function(ApplicationTypes) {
            ApplicationTypes["ITApplications"] = "ITApplications";
            ApplicationTypes["BusinessApplications"] = "BusinessApplications";
            ApplicationTypes["ITConsultingServices"] = "ITConsultingServices";
            ApplicationTypes["BusinessConsultingServices"] = "BusinessConsultingServices";
        })(UserFavourite.ApplicationTypes || (UserFavourite.ApplicationTypes = {}));
        (function(NotCriticalFailure) {
            NotCriticalFailure["ItemExist"] = "ItemExist";
            NotCriticalFailure["ItemNotExist"] = "ItemNotExist";
            NotCriticalFailure["MaximumQuotaReached"] = "MaximumQuotaReached";
        })(UserFavourite.NotCriticalFailure || (UserFavourite.NotCriticalFailure = {}));
        (function(FetchDataStatus) {
            FetchDataStatus["Invalid"] = "Invalid";
            FetchDataStatus["IsFetching"] = "IsFetching";
            FetchDataStatus["Valid"] = "Valid";
            FetchDataStatus["Failure"] = "Failure";
        })(UserFavourite.FetchDataStatus || (UserFavourite.FetchDataStatus = {}));
        (function(DataItemModifyStatus) {
            DataItemModifyStatus["Delete"] = "Delete";
            DataItemModifyStatus["Upsert"] = "Upsert";
            DataItemModifyStatus["None"] = "None";
            // after an operation has finished
            DataItemModifyStatus["Done"] = "Done";
        })(UserFavourite.DataItemModifyStatus || (UserFavourite.DataItemModifyStatus = {}));
        UserFavourite.ViewEndpoint = '/view/favourites';
    })(Constants.UserFavourite || (Constants.UserFavourite = {}));
    (function(ODataError) {
        ODataError.DefaultCode = 500;
        ODataError.DefaultMessage = 'Error Object Not Found, Default to Internal Server Error';
        ODataError.DefaultMessageCircularObject = 'Circular Object Cannot Expand for Details';
        ODataError.DefaultMessageHandle = (error)=>`Error Message Not Found, Showing Original Error Object: ${stringifyError(error)}`;
    })(Constants.ODataError || (Constants.ODataError = {}));
    (function(AccessToken) {
        AccessToken.DefaultHost = 'https://login.microsoftonline.com/';
        AccessToken.DefaultCommonPath = '/oauth2/token';
    })(Constants.AccessToken || (Constants.AccessToken = {}));
    (function(appSourceUrls) {
        appSourceUrls.prod = 'https://appsource.microsoft.com';
        appSourceUrls.df = 'https://appgallery.spza-staging.net';
        appSourceUrls.canary = 'https://appgallery.spza-canary.net';
        appSourceUrls.development = 'http://localhost:3000/';
    })(Constants.appSourceUrls || (Constants.appSourceUrls = {}));
    (function(Header) {
        Header.classNamePrefix = 'spza-header';
        Header.localizationNamePrefix = 'Appsource_Header';
        (function(Classname) {
            Classname.itemActive = 'active';
            Classname.itemNotActive = 'inactive';
        })(Header.Classname || (Header.Classname = {}));
    })(Constants.Header || (Constants.Header = {}));
    (function(UserInteractionType) {
        UserInteractionType["Touch"] = "Touch";
        UserInteractionType["Mouse"] = "Mouse";
    })(Constants.UserInteractionType || (Constants.UserInteractionType = {}));
    (function(EventType) {
        EventType["None"] = "none";
        EventType["Click"] = "click";
        EventType["MouseEnter"] = "mouseenter";
        EventType["ReactMouseEnter"] = "react-mouseenter";
        EventType["MouseLeave"] = "mouseleave";
        EventType["ReactMouseLeave"] = "react-mouseleave";
        EventType["KeyDown"] = "keydown";
        EventType["KeyUp"] = "keyup";
        EventType["Blur"] = "blur";
    })(Constants.EventType || (Constants.EventType = {}));
    (function(UserActionComponentType) {
        UserActionComponentType["Dialog"] = "Dialog";
        UserActionComponentType["DropdownOptionItem"] = "DropdownOptionItem";
    })(Constants.UserActionComponentType || (Constants.UserActionComponentType = {}));
    (function(UserComponent) {
        (function(DropdownItemName) {
            DropdownItemName["userAction"] = "userAction";
            DropdownItemName["userFavourite"] = "userFavourite";
            DropdownItemName["feedback"] = "feeback";
        })(UserComponent.DropdownItemName || (UserComponent.DropdownItemName = {}));
        UserComponent.dropdownItemNameToClassName = {
            ["userAction"]: 'userActions .userTabSignOut button',
            ["userFavourite"]: 'spza-user-favourite-navigation-bar-button-container',
            ["feeback"]: 'spza_feedback'
        };
        UserComponent.dropdownItemClassNameArray = Object.keys(UserComponent.dropdownItemNameToClassName).map((key)=>UserComponent.dropdownItemNameToClassName[`${key}`]);
        UserComponent.activeClassName = 'dropdown-item-active';
        UserComponent.dropdownOptionContainerClassName = 'spza-user-mobile-nav-bar-dropdown';
        UserComponent.dropdownActiveOptionContainerClassName = `${UserComponent.dropdownOptionContainerClassName}.active`;
        UserComponent.dropdownValueClassName = 'spza-user-mobile-container .spza-user-nav-bar-button';
        UserComponent.dropdownContainerClassName = 'spza-user-mobile-container';
    })(Constants.UserComponent || (Constants.UserComponent = {}));
    Constants.MACPrivacyTermsURL = 'https://aka.ms/azuremarketplaceterms';
    Constants.HyperfishEntityId = 'hyperfish.8437f635-56d2-402b-bb8b-2b5549267c61';
    Constants.IgnoredPricingEntityId = 'dummy';
    (function(ErrorCodes) {
        ErrorCodes[ErrorCodes["XSS"] = 1] = "XSS";
    })(Constants.ErrorCodes || (Constants.ErrorCodes = {}));
    Constants.ServicesIdWithBadge = {
        'bardess.customer-360-powered-by-zero2hero': 1,
        'publicis-sapient.rapid_commerce': 2,
        'xentit.azure-xentit-trendmicro-qualys-hcss-12months': 3,
        'rcg-us.rcg-enable-credit-analytics': 4,
        'sirrus7.sirrus7-devops-acceleration-engine': 5,
        'new-signature.eos_appfactory': 6,
        'prodware.devicetone_iot_for_connected_field_service': 7,
        'avanadeinc.intelligent_ma_due_diligence': 8,
        'rivermeadowsoftwareinc.rapid-datacenter-consolidation-jumpstart': 9,
        'barhead_solutions.unison_p2p': 10
    };
    Constants.appSourceApplicationTargetName = 'appsource';
    (function(JsllCTAId) {
        JsllCTAId.Contact = 'CTA_Contact';
        JsllCTAId.ContactMe = 'CTA_ContactMe';
        JsllCTAId.Select = 'CTA_Select';
        JsllCTAId.Get = 'CTA_Get';
        JsllCTAId.Try = 'CTA_Try';
        JsllCTAId.RequestTrial = 'CTA_ContactMe';
        JsllCTAId.TestDrive = 'CTA_TestDrive';
        JsllCTAId.Service = 'CTA_Inquire';
        JsllCTAId.Purchase = 'CTA_Get';
        JsllCTAId.MailALink = 'CTA_MailMeALink';
        JsllCTAId.Configure = 'CTA_Configure';
        JsllCTAId.ContactPartner = 'CTA_ContactPartner';
        JsllCTAId.RepeatTestDrive = 'CTA_RepeatTestDrive';
        JsllCTAId.RetryTestDrive = 'CTA_RetryTestDrive';
        JsllCTAId.Continue = 'CTA_Continue';
        JsllCTAId.Close = 'CTA_Close';
        JsllCTAId.Done = 'CTA_Done';
        JsllCTAId.SubmitFeedback = 'CTA_SubmitFeedback';
        JsllCTAId.SendFeedbackEmail = 'CTA_SendFeedbackEmail';
        JsllCTAId.WriteReview = 'CTA_WriteReview';
        JsllCTAId.UpdateReview = 'CTA_UpdateReview';
        JsllCTAId.SubmitReview = 'CTA_SubmitReview';
        JsllCTAId.DeleteReview = 'CTA_DeleteReview';
        JsllCTAId.SignIn = 'CTA_SignIn';
        JsllCTAId.SignUp = 'CTA_SignUp';
        JsllCTAId.ViewAllButton = 'CTA_ViewAllButton';
        JsllCTAId.ClearFilters = 'CTA_ClearFilters';
        JsllCTAId.DownloadSample = 'CTA_DownloadSample';
        JsllCTAId.Add = 'CTA_Add';
        JsllCTAId.BuyLicense = 'CTA_BuyLicense';
        JsllCTAId.Install = 'CTA_Install';
        JsllCTAId.AlreadyPurchased = 'CTA_AlreadyPurchased';
        JsllCTAId.Partner = 'CTA_Partner';
    })(Constants.JsllCTAId || (Constants.JsllCTAId = {}));
    (function(JsllSaas) {
        JsllSaas.OrderConfirmed = 'OrderConfirmed';
        JsllSaas.TransactableSaasPdpView = 'TransactableSaasPdpView';
        JsllSaas.SaasTransactable = 'SaaS transactable';
        JsllSaas.SaasNonTransactable = 'SaaS non-transactable';
        JsllSaas.ViewImage = 'ViewImage';
        JsllSaas.ViewImageOfVideo = 'ViewImageOfVideo';
        JsllSaas.WatchVideo = 'WatchVideo';
        JsllSaas.SignIn = 'SignIn';
        JsllSaas.SignInModalShow = 'SignInModalShow';
    })(Constants.JsllSaas || (Constants.JsllSaas = {}));
    (function(JsllCheckout) {
        JsllCheckout.RedirectButton = 'RedirectButton';
        JsllCheckout.NewCustomer = 'NewCustomer';
    })(Constants.JsllCheckout || (Constants.JsllCheckout = {}));
    (function(AzureExpertsMSPApps) {
        AzureExpertsMSPApps[AzureExpertsMSPApps["ans_group.glasssaas"] = 0] = "ans_group.glasssaas";
        AzureExpertsMSPApps[AzureExpertsMSPApps["capside.enzime-azure-code-deployments-capside"] = 1] = "capside.enzime-azure-code-deployments-capside";
        AzureExpertsMSPApps[AzureExpertsMSPApps["capside.replica-azure-cloud-governance-capside"] = 2] = "capside.replica-azure-cloud-governance-capside";
        AzureExpertsMSPApps[AzureExpertsMSPApps["elasticbox.elasticbox-enterprise"] = 3] = "elasticbox.elasticbox-enterprise";
        AzureExpertsMSPApps[AzureExpertsMSPApps["comparex.portfolio-management-platform"] = 4] = "comparex.portfolio-management-platform";
        AzureExpertsMSPApps[AzureExpertsMSPApps["comparex.sam2go-nextgen-platform"] = 5] = "comparex.sam2go-nextgen-platform";
        AzureExpertsMSPApps[AzureExpertsMSPApps["comparex.ucm-insights"] = 6] = "comparex.ucm-insights";
        AzureExpertsMSPApps[AzureExpertsMSPApps["coretek.coretekams"] = 7] = "coretek.coretekams";
        AzureExpertsMSPApps[AzureExpertsMSPApps["crayon-group-as-1129016.cloud_iq_saas"] = 8] = "crayon-group-as-1129016.cloud_iq_saas";
        AzureExpertsMSPApps[AzureExpertsMSPApps["hanu.hanu-insight-v2"] = 9] = "hanu.hanu-insight-v2";
        AzureExpertsMSPApps[AzureExpertsMSPApps["hanu.hanu-managed-services"] = 10] = "hanu.hanu-managed-services";
        AzureExpertsMSPApps[AzureExpertsMSPApps["hcl-technologies.hcl17cp1104"] = 11] = "hcl-technologies.hcl17cp1104";
        AzureExpertsMSPApps[AzureExpertsMSPApps["ibm.ibm_security_access_manager"] = 12] = "ibm.ibm_security_access_manager";
        AzureExpertsMSPApps[AzureExpertsMSPApps["ibm.qradar_security_analytics"] = 13] = "ibm.qradar_security_analytics";
        AzureExpertsMSPApps[AzureExpertsMSPApps["infosysltd.infosys-analytics-workbench"] = 14] = "infosysltd.infosys-analytics-workbench";
        AzureExpertsMSPApps[AzureExpertsMSPApps["infront-consulting-group-ltd.beekeeper-patch_maangement"] = 15] = "infront-consulting-group-ltd.beekeeper-patch_maangement";
        AzureExpertsMSPApps[AzureExpertsMSPApps["infront-consulting-group-ltd.hive-self-service-portal"] = 16] = "infront-consulting-group-ltd.hive-self-service-portal";
        AzureExpertsMSPApps[AzureExpertsMSPApps["linkbynet.linkbynet_1"] = 17] = "linkbynet.linkbynet_1";
        AzureExpertsMSPApps[AzureExpertsMSPApps["new-signature.ef2bfc07-9398-483d-b46f-78bccae4cb42"] = 18] = "new-signature.ef2bfc07-9398-483d-b46f-78bccae4cb42";
        AzureExpertsMSPApps[AzureExpertsMSPApps["wipro_india.botwiproapi"] = 19] = "wipro_india.botwiproapi";
        AzureExpertsMSPApps[AzureExpertsMSPApps["wipro_india.facewiproapi"] = 20] = "wipro_india.facewiproapi";
        AzureExpertsMSPApps[AzureExpertsMSPApps["wipro_india.imageclassificationwiproapi"] = 21] = "wipro_india.imageclassificationwiproapi";
        AzureExpertsMSPApps[AzureExpertsMSPApps["wipro_india.wca"] = 22] = "wipro_india.wca";
        AzureExpertsMSPApps[AzureExpertsMSPApps["wipro_india.wiprotexact"] = 23] = "wipro_india.wiprotexact";
    })(Constants.AzureExpertsMSPApps || (Constants.AzureExpertsMSPApps = {}));
    (function(ProductBitmaskFieldNames) {
        ProductBitmaskFieldNames["backendKey"] = "backendKey";
        ProductBitmaskFieldNames["urlKey"] = "urlKey";
    })(Constants.ProductBitmaskFieldNames || (Constants.ProductBitmaskFieldNames = {}));
    (function(SearchFieldNames) {
        SearchFieldNames["linkedAddIns"] = "linkedAddIns";
        SearchFieldNames["linkedAddInsTypes"] = "LinkedAddInsTypes";
    })(Constants.SearchFieldNames || (Constants.SearchFieldNames = {}));
    (function(SearchSortingOption) {
        SearchSortingOption["BestMatch"] = "Best Match";
        SearchSortingOption["Popularity"] = "Popularity";
        SearchSortingOption["RatingAverage"] = "Rating Average";
        SearchSortingOption["RecentlyUpdated"] = "Recently Updated";
    })(Constants.SearchSortingOption || (Constants.SearchSortingOption = {}));
    (function(LicenseManagementType) {
        LicenseManagementType["MicrosoftManaged"] = "MicrosoftManaged";
        LicenseManagementType["ISVManaged"] = "ISVManaged";
    })(Constants.LicenseManagementType || (Constants.LicenseManagementType = {}));
    (function(LicenseModel) {
        LicenseModel["Freemium"] = "Freemium";
    })(Constants.LicenseModel || (Constants.LicenseModel = {}));
    (function(UiRole) {
        UiRole[UiRole["Admin"] = 1] = "Admin";
        UiRole[UiRole["Other"] = 2] = "Other";
    })(Constants.UiRole || (Constants.UiRole = {}));
    (function(TermPeriod) {
        TermPeriod["Month"] = "month";
        TermPeriod["Year"] = "year";
    })(Constants.TermPeriod || (Constants.TermPeriod = {}));
    (function(TermId) {
        // Entitlement renew monthly
        TermId["Monthly"] = "hjdtn7tfnxcy";
        // Entitlement renew yearly
        TermId["Yearly"] = "nm5o4wf9fbfy";
        // Entitlement first month free then renew monthly
        TermId["TrialMonthly"] = "ccdjsqgba7zo";
        // Entitlement first month free then renew yearly
        TermId["TrialYearly"] = "o6p5ue5yng9o";
    })(Constants.TermId || (Constants.TermId = {}));
})(Constants || (Constants = {}));
export var OfferType = /*#__PURE__*/ function(OfferType) {
    OfferType[OfferType["Other"] = 0] = "Other";
    OfferType[OfferType["VirtualMachine"] = 1] = "VirtualMachine";
    OfferType[OfferType["DevService"] = 2] = "DevService";
    OfferType[OfferType["SolutionTemplate"] = 3] = "SolutionTemplate";
    OfferType[OfferType["ManagedApp"] = 4] = "ManagedApp";
    OfferType[OfferType["SaaSApp"] = 5] = "SaaSApp";
    OfferType[OfferType["Container"] = 6] = "Container";
    OfferType[OfferType["ContainerApp"] = 7] = "ContainerApp";
    OfferType[OfferType["CrossChargedManagedApp"] = 8] = "CrossChargedManagedApp";
    OfferType[OfferType["AAD"] = 9] = "AAD";
    OfferType[OfferType["IoTEdgeModule"] = 10] = "IoTEdgeModule";
    OfferType[OfferType["PowerBICustomVisual"] = 11] = "PowerBICustomVisual";
    // 'Mixed' should be the last value and is special
    // It implies multiple offer types
    // If we ever used this as a flag (bitwise operation),
    // remember that 'Mixed' is a special case
    // Add new offer types above
    OfferType[OfferType["Mixed"] = 2147483647] = "Mixed";
    return OfferType;
}({});
export var PlanPricingType = /*#__PURE__*/ function(PlanPricingType) {
    PlanPricingType[PlanPricingType["None"] = 1] = "None";
    PlanPricingType[PlanPricingType["VM"] = 2] = "VM";
    PlanPricingType[PlanPricingType["SimplePlanPricing"] = 3] = "SimplePlanPricing";
    PlanPricingType[PlanPricingType["SolutionTemplate"] = 4] = "SolutionTemplate";
    return PlanPricingType;
}({});
(function(Plan) {
    Plan.displayRank = 'displayRank';
})(Plan || (Plan = {}));
export const supportedCountries = [
    {
        countryCode: 'AF',
        name: 'Afghanistan',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'AL',
        name: 'Albania',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'DZ',
        name: 'Algeria',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'AD',
        name: 'Andorra',
        currencyCode: 'EUR',
        consentRequired: "unknown"
    },
    {
        countryCode: 'AO',
        name: 'Angola',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'AR',
        name: 'Argentina',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'AM',
        name: 'Armenia',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'AU',
        name: 'Australia',
        currencyCode: 'AUD',
        consentRequired: "optin"
    },
    {
        countryCode: 'AT',
        name: 'Austria',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'AZ',
        name: 'Azerbaijan',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'BH',
        name: 'Bahrain',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'BD',
        name: 'Bangladesh',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'BB',
        name: 'Barbados',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'BY',
        name: 'Belarus',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'BE',
        name: 'Belgium',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'BZ',
        name: 'Belize',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'BM',
        name: 'Bermuda',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'BO',
        name: 'Bolivia',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'BA',
        name: 'Bosnia and Herzegovina',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'BW',
        name: 'Botswana',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'BR',
        name: 'Brazil',
        currencyCode: 'BRL',
        consentRequired: "notice"
    },
    {
        countryCode: 'BN',
        name: 'Brunei',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'BG',
        name: 'Bulgaria',
        currencyCode: 'EUR',
        consentRequired: "notice"
    },
    {
        countryCode: 'CM',
        name: 'Cameroon',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'CA',
        name: 'Canada',
        currencyCode: 'CAD',
        consentRequired: "optin"
    },
    {
        countryCode: 'CV',
        name: 'Cabo Verde',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'KY',
        name: 'Cayman Islands',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'CL',
        name: 'Chile',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'CO',
        name: 'Colombia',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'CR',
        name: 'Costa Rica',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'CI',
        name: 'Côte d"Ivoire',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'HR',
        name: 'Croatia',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'CW',
        name: 'Curaçao',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'CY',
        name: 'Cyprus',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'CZ',
        name: 'Czech Republic',
        currencyCode: 'CZK',
        consentRequired: "optout"
    },
    {
        countryCode: 'DK',
        name: 'Denmark',
        currencyCode: 'DKK',
        consentRequired: "optin"
    },
    {
        countryCode: 'DO',
        name: 'Dominican Republic',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'EC',
        name: 'Ecuador',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'EG',
        name: 'Egypt',
        currencyCode: 'EGP',
        consentRequired: "optout"
    },
    {
        countryCode: 'SV',
        name: 'El Salvador',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'EE',
        name: 'Estonia',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'ET',
        name: 'Ethiopia',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'FO',
        name: 'Faroe Islands',
        currencyCode: 'DKK',
        consentRequired: "unknown"
    },
    {
        countryCode: 'FJ',
        name: 'Fiji',
        currencyCode: 'AUD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'FI',
        name: 'Finland',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'FR',
        name: 'France',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'GE',
        name: 'Georgia',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'DE',
        name: 'Germany',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'GH',
        name: 'Ghana',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'GR',
        name: 'Greece',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'GT',
        name: 'Guatemala',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'HN',
        name: 'Honduras',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'HK',
        name: 'Hong Kong SAR',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'HU',
        name: 'Hungary',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'IS',
        name: 'Iceland',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'IN',
        name: 'India',
        currencyCode: 'INR',
        consentRequired: "notice"
    },
    {
        countryCode: 'ID',
        name: 'Indonesia',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'IQ',
        name: 'Iraq',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'IE',
        name: 'Ireland',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'IL',
        name: 'Israel',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'IT',
        name: 'Italy',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'JM',
        name: 'Jamaica',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'JP',
        name: 'Japan',
        currencyCode: 'JPY',
        consentRequired: "optout"
    },
    {
        countryCode: 'JO',
        name: 'Jordan',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'KZ',
        name: 'Kazakhstan',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'KE',
        name: 'Kenya',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'KR',
        name: 'Korea (South)',
        currencyCode: 'KRW',
        consentRequired: "optin"
    },
    {
        countryCode: 'KW',
        name: 'Kuwait',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'KG',
        name: 'Kyrgyzstan',
        currencyCode: 'USD',
        consentRequired: "exclude"
    },
    {
        countryCode: 'LV',
        name: 'Latvia',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'LB',
        name: 'Lebanon',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'LY',
        name: 'Libya',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'LI',
        name: 'Liechtenstein',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'LT',
        name: 'Lithuania',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'LU',
        name: 'Luxembourg',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'MO',
        name: 'Macao SAR',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'MK',
        name: 'North Macedonia',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'MY',
        name: 'Malaysia',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'MT',
        name: 'Malta',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'MU',
        name: 'Mauritius',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'MX',
        name: 'Mexico',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'MD',
        name: 'Moldova',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'MC',
        name: 'Monaco',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'MN',
        name: 'Mongolia',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'ME',
        name: 'Montenegro',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'MA',
        name: 'Morocco',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'NA',
        name: 'Namibia',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'NP',
        name: 'Nepal',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'NL',
        name: 'Netherlands',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'NI',
        name: 'Nicaragua',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'NZ',
        name: 'New Zealand',
        currencyCode: 'NZD',
        consentRequired: "optin"
    },
    {
        countryCode: 'NG',
        name: 'Nigeria',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'NO',
        name: 'Norway',
        currencyCode: 'NOK',
        consentRequired: "optin"
    },
    {
        countryCode: 'OM',
        name: 'Oman',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'PK',
        name: 'Pakistan',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'PS',
        name: 'Palestinian Authority',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'PA',
        name: 'Panama',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'PY',
        name: 'Paraguay',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'PE',
        name: 'Peru',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'PH',
        name: 'Philippines',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'PL',
        name: 'Poland',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'PT',
        name: 'Portugal',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'PR',
        name: 'Puerto Rico',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'QA',
        name: 'Qatar',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'RO',
        name: 'Romania',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'RU',
        name: 'Russia',
        currencyCode: 'RUB',
        consentRequired: "optin"
    },
    {
        countryCode: 'RW',
        name: 'Rwanda',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'KN',
        name: 'Saint Kitts and Nevis',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'SA',
        name: 'Saudi Arabia',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'SN',
        name: 'Senegal',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'RS',
        name: 'Serbia',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'SG',
        name: 'Singapore',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'SK',
        name: 'Slovakia',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'SI',
        name: 'Slovenia',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'ZA',
        name: 'South Africa',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'ES',
        name: 'Spain',
        currencyCode: 'EUR',
        consentRequired: "optin"
    },
    {
        countryCode: 'LK',
        name: 'Sri Lanka',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'SE',
        name: 'Sweden',
        currencyCode: 'SEK',
        consentRequired: "optin"
    },
    {
        countryCode: 'CH',
        name: 'Switzerland',
        currencyCode: 'CHF',
        consentRequired: "optin"
    },
    {
        countryCode: 'TW',
        name: 'Taiwan',
        currencyCode: 'TWD',
        consentRequired: "optin"
    },
    {
        countryCode: 'TJ',
        name: 'Tajikistan',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'TZ',
        name: 'Tanzania',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'TH',
        name: 'Thailand',
        currencyCode: 'USD',
        consentRequired: "optout"
    },
    {
        countryCode: 'TT',
        name: 'Trinidad and Tobago',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'TN',
        name: 'Tunisia',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'TR',
        name: 'Turkey',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'TM',
        name: 'Turkmenistan',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'VA',
        name: 'Vatican City (Holy See)',
        currencyCode: 'EUR',
        consentRequired: "unknown"
    },
    {
        countryCode: 'VI',
        name: 'Virgin Islands of the United States',
        currencyCode: 'USD',
        consentRequired: "unknown"
    },
    {
        countryCode: 'UG',
        name: 'Uganda',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'UA',
        name: 'Ukraine',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'AE',
        name: 'United Arab Emirates',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'GB',
        name: 'United Kingdom',
        currencyCode: 'GB',
        consentRequired: "optin"
    },
    {
        countryCode: 'US',
        name: 'United States',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'UY',
        name: 'Uruguay',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'UZ',
        name: 'Uzbekistan',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'VE',
        name: 'Venezuela',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'VN',
        name: 'Vietnam',
        currencyCode: 'USD',
        consentRequired: "optin"
    },
    {
        countryCode: 'YE',
        name: 'Yemen',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'ZM',
        name: 'Zambia',
        currencyCode: 'USD',
        consentRequired: "notice"
    },
    {
        countryCode: 'ZW',
        name: 'Zimbabwe',
        currencyCode: 'USD',
        consentRequired: "notice"
    }
];
export var Environment = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Dogfood"] = "df";
    Environment["Canary"] = "canary";
    Environment["Test"] = "test";
    Environment["Production"] = "prod";
    return Environment;
}({});
export const UNAUTHENTICATED_ROUTES = {
    '/api/log': false,
    '/api/logOutRequests': false,
    '/view': false,
    '/api': false,
    '/api/userreview': true
};
export var OneDSEnvs = /*#__PURE__*/ function(OneDSEnvs) {
    OneDSEnvs["Production"] = "production";
    OneDSEnvs["Canary"] = "preprod";
    OneDSEnvs["Dogfood"] = "ppe";
    OneDSEnvs["Internal"] = "dev";
    OneDSEnvs["Test"] = "test";
    return OneDSEnvs;
}({});
export const LocalizationSettings = {
    defaultLng: 'en-US',
    defaultNS: 'header'
};
export const ResourcesFiles = {
    resources: 'resources',
    resourcesMac: 'resourcesMac',
    resourcesAppSource: 'resourcesAppSource',
    header: 'header',
    search: 'search',
    home: 'home',
    taxonomy: 'taxonomy'
};
export var AwaMetaTags = /*#__PURE__*/ function(AwaMetaTags) {
    AwaMetaTags["correlationId"] = "awa-correlationId";
    AwaMetaTags["locale"] = "awa-locale";
    AwaMetaTags["signedIn"] = "awa-signedIn";
    AwaMetaTags["version"] = "awa-version";
    AwaMetaTags["region"] = "awa-region";
    return AwaMetaTags;
}({});
export var LocaleStringStyles = /*#__PURE__*/ function(LocaleStringStyles) {
    LocaleStringStyles["Currency"] = "currency";
    return LocaleStringStyles;
}({});
export const allBillingCountries = [
    {
        name: 'United States',
        transactable: true,
        countryCode: 'US',
        currency: 'USD'
    },
    {
        name: 'Afghanistan',
        transactable: true,
        countryCode: 'AF',
        currency: 'USD'
    },
    {
        name: 'Åland Islands',
        currency: 'USD',
        countryCode: 'AX'
    },
    {
        name: 'Albania',
        transactable: true,
        countryCode: 'AL',
        currency: 'USD'
    },
    {
        name: 'Algeria',
        transactable: true,
        countryCode: 'DZ',
        currency: 'USD'
    },
    {
        name: 'American Samoa',
        countryCode: 'AS',
        currency: 'USD'
    },
    {
        name: 'Andorra',
        transactable: true,
        countryCode: 'AD',
        currency: 'EUR'
    },
    {
        name: 'Angola',
        transactable: true,
        countryCode: 'AO',
        currency: 'USD'
    },
    {
        name: 'Anguilla',
        countryCode: 'AI',
        currency: 'USD'
    },
    {
        name: 'Antarctica',
        countryCode: 'AQ',
        currency: 'USD'
    },
    {
        name: 'Antigua and Barbuda',
        countryCode: 'AG',
        currency: 'USD'
    },
    {
        name: 'Argentina',
        transactable: true,
        countryCode: 'AR',
        currency: 'USD'
    },
    {
        name: 'Armenia',
        transactable: true,
        countryCode: 'AM',
        currency: 'USD'
    },
    {
        name: 'Aruba',
        countryCode: 'AW',
        currency: 'USD'
    },
    {
        name: 'Australia',
        transactable: true,
        countryCode: 'AU',
        currency: 'AUD'
    },
    {
        name: 'Austria',
        transactable: true,
        countryCode: 'AT',
        currency: 'EUR'
    },
    {
        name: 'Azerbaijan',
        transactable: true,
        countryCode: 'AZ',
        currency: 'USD'
    },
    {
        name: 'Bahamas',
        countryCode: 'BS',
        currency: 'USD'
    },
    {
        name: 'Bahrain',
        transactable: true,
        countryCode: 'BH',
        currency: 'USD'
    },
    {
        name: 'Bangladesh',
        transactable: true,
        countryCode: 'BD',
        currency: 'USD'
    },
    {
        name: 'Barbados',
        transactable: true,
        countryCode: 'BB',
        currency: 'USD'
    },
    {
        name: 'Belarus',
        transactable: true,
        countryCode: 'BY',
        currency: 'USD'
    },
    {
        name: 'Belgium',
        transactable: true,
        countryCode: 'BE',
        currency: 'EUR'
    },
    {
        name: 'Belize',
        transactable: true,
        countryCode: 'BZ',
        currency: 'USD'
    },
    {
        name: 'Benin',
        countryCode: 'BJ',
        currency: 'USD'
    },
    {
        name: 'Bermuda',
        transactable: true,
        countryCode: 'BM',
        currency: 'USD'
    },
    {
        name: 'Bhutan',
        countryCode: 'BT',
        currency: 'USD'
    },
    {
        name: 'Bolivia',
        transactable: true,
        countryCode: 'BO',
        currency: 'USD'
    },
    {
        name: 'Bonaire, Saint Eustatius and Saba',
        countryCode: 'BQ',
        currency: 'USD'
    },
    {
        name: 'Bosnia and Herzegovina',
        transactable: true,
        countryCode: 'BA',
        currency: 'USD'
    },
    {
        name: 'Botswana',
        transactable: true,
        countryCode: 'BW',
        currency: 'USD'
    },
    {
        name: 'Bouvet Island',
        countryCode: 'BV',
        currency: 'USD'
    },
    {
        name: 'Brazil',
        transactable: true,
        countryCode: 'BR',
        currency: 'BRL'
    },
    {
        name: 'British Indian Ocean Territory',
        countryCode: 'IO',
        currency: 'USD'
    },
    {
        name: 'British Virgin Islands',
        countryCode: 'VG',
        currency: 'USD'
    },
    {
        name: 'Brunei',
        transactable: true,
        countryCode: 'BN',
        currency: 'USD'
    },
    {
        name: 'Bulgaria',
        transactable: true,
        countryCode: 'BG',
        currency: 'EUR'
    },
    {
        name: 'Burkina Faso',
        countryCode: 'BF',
        currency: 'USD'
    },
    {
        name: 'Burundi',
        countryCode: 'BI',
        currency: 'USD'
    },
    {
        name: 'Cabo Verde',
        transactable: true,
        countryCode: 'CV',
        currency: 'USD'
    },
    {
        name: 'Cambodia',
        countryCode: 'KH',
        currency: 'KHR'
    },
    {
        name: 'Cameroon',
        transactable: true,
        countryCode: 'CM',
        currency: 'USD'
    },
    {
        name: 'Canada',
        transactable: true,
        countryCode: 'CA',
        currency: 'CAD'
    },
    {
        name: 'Cayman Islands',
        transactable: true,
        countryCode: 'KY',
        currency: 'USD'
    },
    {
        name: 'Central African Republic',
        countryCode: 'CF',
        currency: 'USD'
    },
    {
        name: 'Chad',
        countryCode: 'TD',
        currency: 'USD'
    },
    {
        name: 'Chile',
        transactable: true,
        countryCode: 'CL',
        currency: 'USD'
    },
    {
        name: 'China',
        countryCode: 'CN',
        currency: 'CNY'
    },
    {
        name: 'Christmas Island',
        countryCode: 'CX',
        currency: 'USD'
    },
    {
        name: 'Cocos (Keeling) Islands',
        countryCode: 'CC',
        currency: 'USD'
    },
    {
        name: 'Colombia',
        transactable: true,
        countryCode: 'CO',
        currency: 'USD'
    },
    {
        name: 'Comoros',
        countryCode: 'KM',
        currency: 'USD'
    },
    {
        name: 'Congo',
        countryCode: 'CG',
        currency: 'USD'
    },
    {
        name: 'Congo (DRC)',
        countryCode: 'CD',
        currency: 'USD'
    },
    {
        name: 'Cook Islands',
        countryCode: 'CK',
        currency: 'USD'
    },
    {
        name: 'Costa Rica',
        transactable: true,
        countryCode: 'CR',
        currency: 'USD'
    },
    {
        name: "Côte d'Ivoire",
        transactable: true,
        countryCode: 'CI',
        currency: 'USD'
    },
    {
        name: 'Croatia',
        transactable: true,
        countryCode: 'HR',
        currency: 'EUR'
    },
    {
        name: 'Curaçao',
        transactable: true,
        countryCode: 'CW',
        currency: 'USD'
    },
    {
        name: 'Cyprus',
        transactable: true,
        countryCode: 'CY',
        currency: 'EUR'
    },
    {
        name: 'Czechia',
        transactable: true,
        countryCode: 'CZ',
        currency: 'EUR'
    },
    {
        name: 'Denmark',
        transactable: true,
        countryCode: 'DK',
        currency: 'DKK'
    },
    {
        name: 'Djibouti',
        countryCode: 'DJ',
        currency: 'USD'
    },
    {
        name: 'Dominica',
        countryCode: 'DM',
        currency: 'USD'
    },
    {
        name: 'Dominican Republic',
        transactable: true,
        countryCode: 'DO',
        currency: 'USD'
    },
    {
        name: 'Ecuador',
        transactable: true,
        countryCode: 'EC',
        currency: 'USD'
    },
    {
        name: 'Egypt',
        transactable: true,
        countryCode: 'EG',
        currency: 'USD'
    },
    {
        name: 'El Salvador',
        transactable: true,
        countryCode: 'SV',
        currency: 'USD'
    },
    {
        name: 'Equatorial Guinea',
        countryCode: 'GQ',
        currency: 'USD'
    },
    {
        name: 'Eritrea',
        countryCode: 'ER',
        currency: 'USD'
    },
    {
        name: 'Estonia',
        transactable: true,
        countryCode: 'EE',
        currency: 'EUR'
    },
    {
        name: 'Ethiopia',
        transactable: true,
        countryCode: 'ET',
        currency: 'USD'
    },
    {
        name: 'Falkland Islands',
        countryCode: 'FK',
        currency: 'USD'
    },
    {
        name: 'Faroe Islands',
        transactable: true,
        countryCode: 'FO',
        currency: 'DKK'
    },
    {
        name: 'Fiji',
        transactable: true,
        countryCode: 'FJ',
        currency: 'AUD'
    },
    {
        name: 'Finland',
        transactable: true,
        countryCode: 'FI',
        currency: 'EUR'
    },
    {
        name: 'France',
        transactable: true,
        countryCode: 'FR',
        currency: 'EUR'
    },
    {
        name: 'French Guiana',
        countryCode: 'GF',
        currency: 'USD'
    },
    {
        name: 'French Polynesia',
        countryCode: 'PF',
        currency: 'USD'
    },
    {
        name: 'French Southern Territories',
        countryCode: 'TF',
        currency: 'USD'
    },
    {
        name: 'Gabon',
        countryCode: 'GA',
        currency: 'USD'
    },
    {
        name: 'Gambia',
        countryCode: 'GM',
        currency: 'USD'
    },
    {
        name: 'Georgia',
        transactable: true,
        countryCode: 'GE',
        currency: 'USD'
    },
    {
        name: 'Germany',
        transactable: true,
        countryCode: 'DE',
        currency: 'EUR'
    },
    {
        name: 'Ghana',
        transactable: true,
        countryCode: 'GH',
        currency: 'USD'
    },
    {
        name: 'Gibraltar',
        countryCode: 'GI',
        currency: 'EUR'
    },
    {
        name: 'Greece',
        transactable: true,
        countryCode: 'GR',
        currency: 'EUR'
    },
    {
        name: 'Greenland',
        countryCode: 'GL',
        currency: 'USD'
    },
    {
        name: 'Grenada',
        countryCode: 'GD',
        currency: 'USD'
    },
    {
        name: 'Guadeloupe',
        countryCode: 'GP',
        currency: 'USD'
    },
    {
        name: 'Guam',
        countryCode: 'GU',
        currency: 'USD'
    },
    {
        name: 'Guatemala',
        transactable: true,
        countryCode: 'GT',
        currency: 'USD'
    },
    {
        name: 'Guernsey',
        countryCode: 'GG',
        currency: 'EUR'
    },
    {
        name: 'Guinea',
        countryCode: 'GN',
        currency: 'USD'
    },
    {
        name: 'Guinea-Bissau',
        countryCode: 'GW',
        currency: 'USD'
    },
    {
        name: 'Guyana',
        countryCode: 'GY',
        currency: 'USD'
    },
    {
        name: 'Haiti',
        countryCode: 'HT',
        currency: 'USD'
    },
    {
        name: 'Heard Island and McDonald Islands',
        countryCode: 'HM',
        currency: 'USD'
    },
    {
        name: 'Honduras',
        transactable: true,
        countryCode: 'HN',
        currency: 'USD'
    },
    {
        name: 'Hong Kong SAR',
        transactable: true,
        countryCode: 'HK',
        currency: 'USD'
    },
    {
        name: 'Hungary',
        transactable: true,
        countryCode: 'HU',
        currency: 'EUR'
    },
    {
        name: 'Iceland',
        transactable: true,
        countryCode: 'IS',
        currency: 'EUR'
    },
    {
        name: 'India',
        transactable: true,
        countryCode: 'IN',
        currency: 'INR'
    },
    {
        name: 'Indonesia',
        transactable: true,
        countryCode: 'ID',
        currency: 'USD'
    },
    {
        name: 'Iraq',
        transactable: true,
        countryCode: 'IQ',
        currency: 'USD'
    },
    {
        name: 'Ireland',
        transactable: true,
        countryCode: 'IE',
        currency: 'EUR'
    },
    {
        name: 'Isle of Man',
        countryCode: 'IM',
        currency: 'USD'
    },
    {
        name: 'Israel',
        transactable: true,
        countryCode: 'IL',
        currency: 'USD'
    },
    {
        name: 'Italy',
        transactable: true,
        countryCode: 'IT',
        currency: 'EUR'
    },
    {
        name: 'Jamaica',
        transactable: true,
        countryCode: 'JM',
        currency: 'USD'
    },
    {
        name: 'Japan',
        transactable: true,
        countryCode: 'JP',
        currency: 'JPY'
    },
    {
        name: 'Jersey',
        countryCode: 'JE',
        currency: 'EUR'
    },
    {
        name: 'Jordan',
        transactable: true,
        countryCode: 'JO',
        currency: 'USD'
    },
    {
        name: 'Kazakhstan',
        transactable: true,
        countryCode: 'KZ',
        currency: 'USD'
    },
    {
        name: 'Kenya',
        transactable: true,
        countryCode: 'KE',
        currency: 'USD'
    },
    {
        name: 'Kiribati',
        countryCode: 'KI',
        currency: 'USD'
    },
    {
        name: 'Korea (South)',
        transactable: true,
        countryCode: 'KR',
        currency: 'KRW'
    },
    {
        name: 'Kosovo',
        countryCode: 'XK',
        currency: 'USD'
    },
    {
        name: 'Kuwait',
        transactable: true,
        countryCode: 'KW',
        currency: 'USD'
    },
    {
        name: 'Kyrgyzstan',
        transactable: true,
        countryCode: 'KG',
        currency: 'USD'
    },
    {
        name: 'Laos',
        countryCode: 'LA',
        currency: 'USD'
    },
    {
        name: 'Latvia',
        transactable: true,
        countryCode: 'LV',
        currency: 'EUR'
    },
    {
        name: 'Lebanon',
        transactable: true,
        countryCode: 'LB',
        currency: 'USD'
    },
    {
        name: 'Lesotho',
        countryCode: 'LS',
        currency: 'USD'
    },
    {
        name: 'Liberia',
        countryCode: 'LR',
        currency: 'USD'
    },
    {
        name: 'Libya',
        transactable: true,
        countryCode: 'LY',
        currency: 'USD'
    },
    {
        name: 'Liechtenstein',
        transactable: true,
        countryCode: 'LI',
        currency: 'EUR'
    },
    {
        name: 'Lithuania',
        transactable: true,
        countryCode: 'LT',
        currency: 'EUR'
    },
    {
        name: 'Luxembourg',
        transactable: true,
        countryCode: 'LU',
        currency: 'EUR'
    },
    {
        name: 'Macao SAR',
        transactable: true,
        countryCode: 'MO',
        currency: 'USD'
    },
    {
        name: 'Madagascar',
        countryCode: 'MG',
        currency: 'USD'
    },
    {
        name: 'Malawi',
        countryCode: 'MW',
        currency: 'USD'
    },
    {
        name: 'Malaysia',
        transactable: true,
        countryCode: 'MY',
        currency: 'USD'
    },
    {
        name: 'Maldives',
        countryCode: 'MV',
        currency: 'USD'
    },
    {
        name: 'Mali',
        countryCode: 'ML',
        currency: 'USD'
    },
    {
        name: 'Malta',
        transactable: true,
        countryCode: 'MT',
        currency: 'EUR'
    },
    {
        name: 'Marshall Islands',
        countryCode: 'MH',
        currency: 'USD'
    },
    {
        name: 'Martinique',
        countryCode: 'MQ',
        currency: 'EUR'
    },
    {
        name: 'Mauritania',
        countryCode: 'MR',
        currency: 'MRO'
    },
    {
        name: 'Mauritius',
        transactable: true,
        countryCode: 'MU',
        currency: 'USD'
    },
    {
        name: 'Mayotte',
        countryCode: 'YT',
        currency: 'EUR'
    },
    {
        name: 'Mexico',
        transactable: true,
        countryCode: 'MX',
        currency: 'USD'
    },
    {
        name: 'Micronesia',
        countryCode: 'FM',
        currency: 'USD'
    },
    {
        name: 'Moldova',
        transactable: true,
        countryCode: 'MD',
        currency: 'USD'
    },
    {
        name: 'Monaco',
        transactable: true,
        countryCode: 'MC',
        currency: 'EUR'
    },
    {
        name: 'Mongolia',
        transactable: true,
        countryCode: 'MN',
        currency: 'USD'
    },
    {
        name: 'Montenegro',
        transactable: true,
        countryCode: 'ME',
        currency: 'USD'
    },
    {
        name: 'Montserrat',
        countryCode: 'MS',
        currency: 'USD'
    },
    {
        name: 'Morocco',
        transactable: true,
        countryCode: 'MA',
        currency: 'USD'
    },
    {
        name: 'Mozambique',
        countryCode: 'MZ',
        currency: 'USD'
    },
    {
        name: 'Myanmar',
        countryCode: 'MM',
        currency: 'USD'
    },
    {
        name: 'Namibia',
        transactable: true,
        countryCode: 'NA',
        currency: 'USD'
    },
    {
        name: 'Nauru',
        countryCode: 'NR',
        currency: 'USD'
    },
    {
        name: 'Nepal',
        transactable: true,
        countryCode: 'NP',
        currency: 'USD'
    },
    {
        name: 'Netherlands',
        transactable: true,
        countryCode: 'NL',
        currency: 'EUR'
    },
    {
        name: 'New Caledonia',
        countryCode: 'NC',
        currency: 'USD'
    },
    {
        name: 'New Zealand',
        transactable: true,
        countryCode: 'NZ',
        currency: 'NZD'
    },
    {
        name: 'Nicaragua',
        transactable: true,
        countryCode: 'NI',
        currency: 'USD'
    },
    {
        name: 'Niger',
        countryCode: 'NE',
        currency: 'USD'
    },
    {
        name: 'Nigeria',
        transactable: true,
        countryCode: 'NG',
        currency: 'USD'
    },
    {
        name: 'Niue',
        countryCode: 'NU',
        currency: 'USD'
    },
    {
        name: 'Norfolk Island',
        countryCode: 'NF',
        currency: 'USD'
    },
    {
        name: 'North Macedonia',
        transactable: true,
        countryCode: 'MK',
        currency: 'USD'
    },
    {
        name: 'Northern Mariana Islands',
        countryCode: 'MP',
        currency: 'USD'
    },
    {
        name: 'Norway',
        transactable: true,
        countryCode: 'NO',
        currency: 'NOK'
    },
    {
        name: 'Oman',
        transactable: true,
        countryCode: 'OM',
        currency: 'USD'
    },
    {
        name: 'Pakistan',
        transactable: true,
        countryCode: 'PK',
        currency: 'USD'
    },
    {
        name: 'Palau',
        countryCode: 'PW',
        currency: 'USD'
    },
    {
        name: 'Palestinian Authority',
        transactable: true,
        countryCode: 'PS',
        currency: 'USD'
    },
    {
        name: 'Panama',
        transactable: true,
        countryCode: 'PA',
        currency: 'USD'
    },
    {
        name: 'Papua New Guinea',
        countryCode: 'PG',
        currency: 'USD'
    },
    {
        name: 'Paraguay',
        transactable: true,
        countryCode: 'PY',
        currency: 'USD'
    },
    {
        name: 'Peru',
        transactable: true,
        countryCode: 'PE',
        currency: 'USD'
    },
    {
        name: 'Philippines',
        transactable: true,
        countryCode: 'PH',
        currency: 'USD'
    },
    {
        name: 'Pitcairn Islands',
        countryCode: 'PN',
        currency: 'USD'
    },
    {
        name: 'Poland',
        transactable: true,
        countryCode: 'PL',
        currency: 'EUR'
    },
    {
        name: 'Portugal',
        transactable: true,
        countryCode: 'PT',
        currency: 'EUR'
    },
    {
        name: 'Puerto Rico',
        transactable: true,
        countryCode: 'PR',
        currency: 'USD'
    },
    {
        name: 'Qatar',
        transactable: true,
        countryCode: 'QA',
        currency: 'USD'
    },
    {
        name: 'Réunion',
        countryCode: 'RE',
        currency: 'EUR'
    },
    {
        name: 'Romania',
        transactable: true,
        countryCode: 'RO',
        currency: 'EUR'
    },
    {
        name: 'Russia',
        transactable: true,
        countryCode: 'RU',
        currency: 'RUB'
    },
    {
        name: 'Rwanda',
        transactable: true,
        countryCode: 'RW',
        currency: 'USD'
    },
    {
        name: 'Saint Barthélemy',
        countryCode: 'BL',
        currency: 'EUR'
    },
    {
        name: 'Saint Helena, Ascension, Tristan da Cunha',
        countryCode: 'SH',
        currency: 'EUR'
    },
    {
        name: 'Saint Kitts and Nevis',
        transactable: true,
        countryCode: 'KN',
        currency: 'USD'
    },
    {
        name: 'Saint Lucia',
        countryCode: 'LC',
        currency: 'USD'
    },
    {
        name: 'Saint Martin',
        countryCode: 'MF',
        currency: 'USD'
    },
    {
        name: 'Saint Pierre and Miquelon',
        countryCode: 'PM',
        currency: 'USD'
    },
    {
        name: 'Saint Vincent and the Grenadines',
        countryCode: 'VC',
        currency: 'USD'
    },
    {
        name: 'Samoa',
        countryCode: 'WS',
        currency: 'USD'
    },
    {
        name: 'San Marino',
        countryCode: 'SM',
        currency: 'EUR'
    },
    {
        name: 'São Tomé and Príncipe',
        countryCode: 'ST',
        currency: 'USD'
    },
    {
        name: 'Saudi Arabia',
        transactable: true,
        countryCode: 'SA',
        currency: 'USD'
    },
    {
        name: 'Senegal',
        transactable: true,
        countryCode: 'SN',
        currency: 'USD'
    },
    {
        name: 'Serbia',
        transactable: true,
        countryCode: 'RS',
        currency: 'USD'
    },
    {
        name: 'Seychelles',
        countryCode: 'SC',
        currency: 'USD'
    },
    {
        name: 'Sierra Leone',
        countryCode: 'SL',
        currency: 'USD'
    },
    {
        name: 'Singapore',
        transactable: true,
        countryCode: 'SG',
        currency: 'USD'
    },
    {
        name: 'Sint Maarten',
        countryCode: 'SX',
        currency: 'USD'
    },
    {
        name: 'Slovakia',
        transactable: true,
        countryCode: 'SK',
        currency: 'EUR'
    },
    {
        name: 'Slovenia',
        transactable: true,
        countryCode: 'SI',
        currency: 'EUR'
    },
    {
        name: 'Solomon Islands',
        countryCode: 'SB',
        currency: 'USD'
    },
    {
        name: 'Somalia',
        countryCode: 'SO',
        currency: 'USD'
    },
    {
        name: 'South Africa',
        transactable: true,
        countryCode: 'ZA',
        currency: 'USD'
    },
    {
        name: 'South Georgia and South Sandwich Islands',
        countryCode: 'GS',
        currency: 'USD'
    },
    {
        name: 'South Sudan',
        countryCode: 'SS',
        currency: 'USD'
    },
    {
        name: 'Spain',
        transactable: true,
        countryCode: 'ES',
        currency: 'EUR'
    },
    {
        name: 'Sri Lanka',
        transactable: true,
        countryCode: 'LK',
        currency: 'USD'
    },
    {
        name: 'Suriname',
        countryCode: 'SR',
        currency: 'USD'
    },
    {
        name: 'Svalbard and Jan Mayen',
        countryCode: 'SJ',
        currency: 'USD'
    },
    {
        name: 'Swaziland',
        countryCode: 'SZ',
        currency: 'USD'
    },
    {
        name: 'Sweden',
        transactable: true,
        countryCode: 'SE',
        currency: 'SEK'
    },
    {
        name: 'Switzerland',
        transactable: true,
        countryCode: 'CH',
        currency: 'CHF'
    },
    {
        name: 'Taiwan',
        transactable: true,
        countryCode: 'TW',
        currency: 'TWD'
    },
    {
        name: 'Tajikistan',
        transactable: true,
        countryCode: 'TJ',
        currency: 'USD'
    },
    {
        name: 'Tanzania',
        transactable: true,
        countryCode: 'TZ',
        currency: 'USD'
    },
    {
        name: 'Thailand',
        transactable: true,
        countryCode: 'TH',
        currency: 'USD'
    },
    {
        name: 'Timor-Leste',
        countryCode: 'TL',
        currency: 'USD'
    },
    {
        name: 'Togo',
        countryCode: 'TG',
        currency: 'USD'
    },
    {
        name: 'Tokelau',
        countryCode: 'TK',
        currency: 'USD'
    },
    {
        name: 'Tonga',
        countryCode: 'TO',
        currency: 'USD'
    },
    {
        name: 'Trinidad and Tobago',
        transactable: true,
        countryCode: 'TT',
        currency: 'USD'
    },
    {
        name: 'Tunisia',
        transactable: true,
        countryCode: 'TN',
        currency: 'USD'
    },
    {
        name: 'Turkey',
        transactable: true,
        countryCode: 'TR',
        currency: 'USD'
    },
    {
        name: 'Turkmenistan',
        transactable: true,
        countryCode: 'TM',
        currency: 'USD'
    },
    {
        name: 'Turks and Caicos Islands',
        countryCode: 'TC',
        currency: 'USD'
    },
    {
        name: 'Tuvalu',
        countryCode: 'TV',
        currency: 'USD'
    },
    {
        name: 'U.S. Outlying Islands',
        countryCode: 'UM',
        currency: 'USD'
    },
    {
        name: 'U.S. Virgin Islands',
        transactable: true,
        countryCode: 'VI',
        currency: 'USD'
    },
    {
        name: 'Uganda',
        transactable: true,
        countryCode: 'UG',
        currency: 'USD'
    },
    {
        name: 'Ukraine',
        transactable: true,
        countryCode: 'UA',
        currency: 'USD'
    },
    {
        name: 'United Arab Emirates',
        transactable: true,
        countryCode: 'AE',
        currency: 'USD'
    },
    {
        name: 'United Kingdom',
        transactable: true,
        countryCode: 'GB',
        currency: 'GBP'
    },
    {
        name: 'Uruguay',
        transactable: true,
        countryCode: 'UY',
        currency: 'USD'
    },
    {
        name: 'Uzbekistan',
        transactable: true,
        countryCode: 'UZ',
        currency: 'USD'
    },
    {
        name: 'Vanuatu',
        countryCode: 'VU',
        currency: 'USD'
    },
    {
        name: 'Vatican City (Holy See)',
        transactable: true,
        countryCode: 'VA',
        currency: 'EUR'
    },
    {
        name: 'Venezuela',
        transactable: true,
        countryCode: 'VE',
        currency: 'USD'
    },
    {
        name: 'Vietnam',
        transactable: true,
        countryCode: 'VN',
        currency: 'USD'
    },
    {
        name: 'Wallis and Futuna',
        countryCode: 'WF',
        currency: 'USD'
    },
    {
        name: 'Yemen',
        transactable: true,
        countryCode: 'YE',
        currency: 'USD'
    },
    {
        name: 'Zambia',
        transactable: true,
        countryCode: 'ZM',
        currency: 'USD'
    },
    {
        name: 'Zimbabwe',
        transactable: true,
        countryCode: 'ZW',
        currency: 'USD'
    }
];
export var SearchType = /*#__PURE__*/ function(SearchType) {
    SearchType["App"] = "App";
    SearchType["ConsultingService"] = "ConsultingService";
    SearchType["CloudIndustry"] = "CloudIndustry";
    return SearchType;
}({});
export var Constants, Plan;
